export default {
  system: {
    name: '管理端',
    home: '仪表盘',
    signOut: '退出',
    myAccount: '我的账号',
    systemLanguage: '系统语言',
    Chinese: '中文',
    English: '英文',
    loggedOut: '您的登录已失效，请重新登录',
    confirmLogout: '确定登出',
    login: '登录',
    logPass: '密码登录',
    SMSLogin: '短信登录',
    sendCode: '获取验证码',
    Resend: '重新获取',
    welcomeBack: '欢迎回来',
    systemName: '慧清仓',
    title: '慧清仓平台管理系统',
    areNotCustomerService: '您不是客服，无权查看',
    noPermission: '您没有权限访问',
    noIp: '未获取到IP信息',
    forgotPass: '忘记密码',
    Expired: '已过期',
    failedIdentityInformation: '没有获取到身份信息，请联系平台处理',
    reconnect: '断线重连...',
    ProductSpecificationIdentifier: '商品规格的身份标识',
    mobileOrEmail: '输入手机号码或电子邮件地址',
    Continue: '继续',
    unreadSystemNotifications: '您有未读通知，立即查看 → ',
    sureLogout: '您确认要登出系统吗？',
    NoData: '暂无数据',
    PleaseUploadPictures: '请上传图片',
    connectQuickBooks: '连接 QuickBooks',
    customerService: '客服',
  },
  table: {
    filter: '当前筛选',
    dataList: '数据列表',
    id: '编号',
    function: '操作',
    ViewAddress: '查看地址',
    productImage: '商品图片',
    yodelServiceCentre: 'Yodel 服务中心及本地地区',
    postcodeDistrict: '邮编区域',
    total: '共 x 条',
    pageSize: '条/页',
    serialNum: "序号",
    completionTime: '完成时间',
  },
  common: {
    warning: '警告',
    cancelled: '已取消'
  },
  button: {
    refresh: '刷新',
    or: '或',
    save: '保存',
    search: '搜索',
    reset: '重置',
    more: '更多',
    download: '下载',
    delete: '删除',
    batchDelete: '批量删除',
    upload: '上传',
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    submit: '提交',
    edit: '编辑',
    clear: '清空',
    details: '详情',
    view: '查看',
    viewDetails: '查看详情',
    log: '日志',
    add: '新增',
    back: '返回',
    select: '选择',
    Review: '审核',
    changeRecord: '变更记录',
    contactSeller: '联系卖家',
    viewProduct: '查看商品',
    Change: '更改',
    Expand: '展开',
    Collapse: '收起',
    Recharge: '充值',
    preview: '预览',
    previewProduct: '预览商品',
  },
  payment: {
    topUpAmount: '充值金额',
    pleaseSelectOrEnterValidTopUpAmount: '请选择或输入有效的充值金额',
    customAmount: '自定义金额',
    amountCannotExceed: '充值金额不能超过999999英镑',
    other: '其他',
    selectPaymentMethod: '选择支付方式',
    ConfirmPay: '确认支付',
    cancelPayment: '取消支付',
    paymentNotSuccessful: '支付不成功',
    paymentDeclined: '支付已被拒绝',
    wasNotCharged: '您的支付未被处理',
    SomeCommonIssues: '一些常见问题包括：',
    VerifyPaymentInformation: '验证支付信息',
    bankHaveFlagged: '支付提供商已标记该交易',
    withdrawalPurchaseLimits: '支付限额或限制',
    ProcessingPayment: '处理支付中',
    committedProtectingInformation: '我们致力于保护您的信息',
    PaymentSuccessful: '支付成功',
    pleaseEnterValidAmount: '请输入有效的金额',
    PleaseSelectPaymentMethod: '请选择支付方式',
    stripePayment: 'Stripe支付',
    wechatPayment: '微信支付',
    paymentAmount: '支付金额',
    scanQrCode: '请使用微信扫描下方二维码进行支付',
    qrCodeExpired: '二维码已过期',
    qrCodeValidity: '二维码有效期',
    loadingQrCode: '加载支付二维码中...',
    paymentSuccess: '支付成功',
    paymentSuccessMessage: '您的支付已成功处理',
    confirmPaymentSuccess: '确认'
  },
  permission: {
    roleName: '角色名称',
    status: '状态',
    roleType: '角色类型',
    AssignMenus: '分配菜单',
    enable: '启用',
    disable: '禁用',
  },
  ums: {
    userId: '用户ID',
    userName: '账号',
    email: '邮箱',
    phone: '电话',
    password: '密码',
    resetPassword: '重置密码',
    createdTime: '创建时间',
    LastModifiedTime: '更新时间',
    notes: '备注',
    description: '描述',
    administratorType: '管理员类型',
    createdBy: '创建人',
    yes: 'Yes',
    no: 'No',
    addRole: '新增角色',
    editRole: '编辑角色',
    menuName: '菜单名称',
    menuNamezh: '菜单名称（中文）',
    menuNameen: '菜单名称（英文）',
    internationalizationVariables: '国际化变量',
    menuIcon: '菜单图标',
    componentName: '组件名称',
    menuLevel: '菜单层级',
    firstLevel: '一级',
    secondLevel: '二级',
    thirdLevel: '三级',
    level: '级',
    DisplayOrNot: '是否显示',
    sort: '排序',
    superiorMenu: '上级菜单',
    menuType: '菜单类型',
    show: '显示',
    hide: '隐藏',
    newPassword: '新密码',
    confirmNewPassword: '确定新密码',
    addUser: '添加用户',
    editUser: '编辑用户',
    assigningRoles: '分配角色',
    selectRoles: '选择角色',
    usernameAlreadyExists: '用户名已存在',
    authWay: '验证',
    byEmail: '邮箱',
    byPhone: '手机号',
    code: '验证码',
    cancellationStatus: '注销状态',
    cancelled: '注销',
    active: '正常',
    webBannerTitle: '商城轮播图设置',
    commodityZoneTitle: '商品专区',
    commodityZoneAddTitle: '新增商品专区',
    commodityZoneEditTitle: '编辑商品专区',
    commodityZoneBasicInfo: '专区基本信息',
    commodityZoneName: '专区名称（中文）',
    commodityZoneNameEn: '专区名称（英文）',
    commodityZoneSubheading: '专区简介（中文）',
    commodityZoneSubheadingEn: '专区简介（英文）',
    commodityZoneSortOrder: '展示排序',
    commodityZoneRelatedProducts: '关联商品配置',
    commodityZoneSelectedProducts: '已选商品',
    commodityZoneSave: '确认创建专区',
    commodityZoneUpdate: '确认保存修改',
    commodityZoneBackToList: '返回列表',
    deletecommodity: '删除商品专区',
    confirmDeletecommodity: '是否确认删除该商品专区？',
    commodityZoneSelectProductRequired: '请至少选择一个关联商品',
    commodityZoneLoadFailed: '未找到对应商品专区数据',
    commodityZoneSize:'当前选择商品个数只能为1或4',
    commodityZoneProfit:'利润',
    commodityZoneStock:'库存',
    webBanner: 'Web端轮播图',
    mobileBanner: '移动端轮播图',
    ChineseVersion: '中文版',
    EnglishVersion: '英文版',
    addBanner: "添加轮播图",
    editBanner: "编辑轮播图",
    version: "版本",
    position: "位置",
    top: "顶部",
    bottom: "底部",
    bannerImg: "banner图片",
    labelText: "标签文字",
    titleText: "标题文字",
    contentText: "内容文字",
    buttonLink: "按钮链接",
    buttonText: "按钮文字",
    buttonBgColor: "按钮背景色",
    buttonTextColor: "按钮文字颜色",
    themeBgColor: "主题背景色",
    themeColor: "主题颜色",
    bannerBasicSettings: '基础设置',
    bannerImageContent: '图片与文案',
    bannerButtonSettings: '按钮设置',
    bannerThemeStyle: '主题样式',
    clickUploadBanner: '点击上传图片',
    bannerUploadTip: '支持 JPG、PNG、BMP，文件不超过 10MB',
    bannerStylePreview: '样式预览',
    bannerRequiredTip: '带 * 为必填项',
    deleteBanner: "删除banner",
    confirmDeleteBanner: "是否确认删除banner",
    emailTaken: '该邮箱已被注册',
    phoneTaken: '该手机号已被注册',
    userNameLimit: '支持字母、数字和下划线，请勿使用敏感词',
    userNameLimit2: '用户名不能包含敏感词HURIX',
    userNameLimit3: '请输入6 到 20 位用户名‌',
    passwordLimit: '请使用大写字母、小写字母、数字及特殊字符中的至少三种，特殊字符包括!@#$%^&*()_+-=[]{};:,.?~`',
    passwordLimit2: '使用了不可用的特殊字符',
    identityWithEmail: '为保护账户安全，请使用邮箱【emailNum】验证身份',
    NoEmailFound: '没有获取到用户邮箱',
    AccountClosed: '已注销',
    platform: '平台',
    buyer: '买家',
    seller: '卖家',
    system: '系统',
    None: '无',
    ChangeUsername: '修改用户名',
    auditor: '审核人',
    auditTime: '审核时间',
  },
  placeholder: {
    input: '请输入',
    select: '请选择',
    selectWarehouse: '请选择仓库',
    height: '高度',
    width: '宽度',
    length: '长度',
    myMoneyTransactionId: '输入平台或外部交易流水号',
    inputGoodsKeywords: '请输入商品名称关键字',
    inputEmailOrPhone: '请输入邮箱或手机号',
    inputOrderNumberOrThirdOrderNumber: '输入订单编号或第三方订单编号',
    inputWarehouseName: '请输入仓库正式名称',
    inputWarehouseEmail: '请输入仓库联系人邮箱',
    from: "自",
    to: "至",
    minPrice: "最低价格",
    maxPrice: "最高价格",
    sellerContact: "输入卖家邮箱 / 卖家手机号",
    buyerContact: "输入分销商邮箱 / 分销商手机号",
    recipientContact: "输入收件人邮箱 / 收件人手机号",
    salesRepContact: "输入销售代表邮箱 / 销售代表手机号",
    accountKeyword: "输入账号/邮箱关键字",
    enterOrderNumber: '输入订单编号',
    startDate: '自',
    endDate: '至',
    productNameKeyword: "请输入商品名称关键字",
    merchantSpuKeyword: "请输入商家SPU关键字",
    merchantSkuKeyword: "输入商家SKU关键字",
    salesRepEmailKeyword: "请输入销售代表邮箱关键字",
    sellerEmailKeyword: "请输入卖家邮箱关键字",
    shopNameKeyword: "请输入店铺名称前两位",
    shopPageShopNameKeyword: "输入店铺名称前两位",
    productVerifyShopNameKeyword: "输入店铺名称前两位",
    productVerifyProductNameKeyword: "输入商品名称关键字",
    customerNameKeyword: "输入客户名称关键字",
    quoteNoKeyword: "输入报价单号关键字",
    warehouseNameKeyword: "输入仓库名称关键字",
    trackingNoKeyword: "输入物流单号",
    returnReasonKeyword: "输入退货原因关键字",
    transactionNoKeyword: "输入交易单号关键字",
    categoryNameKeyword: "输入分类名称关键字",
    brandNameKeyword: "请输入品牌名称关键字",
    roleNameKeyword: "输入角色名称关键字",
    menuNameKeyword: "输入菜单名称关键字",
    inputOrderReturnNo: "输入订单编号/退货编号",
    inputLogisticsNo: "输入退货运单号",
    inputShopName: '请输入店铺名称 / 邮箱',
    emailKeyword: "输入销售代表邮箱/卖家邮箱",
    buyerEmailKeyword: "请输入销售代表邮箱/买家邮箱",
    inputSearchKeyword: '输入商品名称关键字/SSIN',
    inputSearchCategoryProductSsin: '搜索分类 / 商品 / SSIN',
    distEmailInput: "请输入分销商邮箱",
  },
  shop: {
    approved: '审核通过',
    unApproved: '审核未通过',
    shopName: '卖家名称',
    staff: '员工名称',
    subAccountList: '子账号',
    subAccountDrawerSubtitle: '查看当前货主账号下的子账号、状态及创建信息',
    subAccountListTitle: '子账号列表',
    subAccountTotal: '子账号总数',
    subAccountEnabled: '启用中',
    subAccountDisabled: '已停用',
    subAccountRecordCount: '共 {count} 条子账号记录',
    editChargeItem: '编辑收费项',
    logo: 'Logo',
    companyInfo: '公司信息',
    companyName: '公司名称',
    registrationNo: '注册号',
    eoriNo: 'EORI',
    vatNo: 'VAT',
    contactPerson: '联系人',
    SellerInfo: '卖家信息',
    enterResult: '审核结果',
    userName: '用户名',
    viewImage: '查看图片',
    applicant: '申请人',
    applicationTime: '申请时间',
    certificateFiles: '合同',
    certificateFilesWarning: '企业注册文件、增值税凭证或EORI进出口税号材料',
    certificateFilesWarningCnEnterprise: '企业注册文件或增值税凭证材料',
    certificateFilesWarningCnIndividual: '经营者亲笔签名及对应身份证号码材料',
    certificateFilesWarningUkEnterprise: '企业注册编号、增值税号或英国EOR进出口税号材料',
    certificateFilesWarningUkIndividual: '注册编号、增值税号材料',
    withdrawalContractInfo: '合同资料',
    hurixShipperServiceContract: 'HURIX 货主服务合同',
    withdrawalContract: '合同',
    downloadContractTemplate: '合同模板',
    downloadContractTemplateBtn: '下载 HURIX 货主服务合同模板',
    withdrawalContractTemplateName: '提现合同模板',
    auditPrompt: '审核提示',
    auditPrompt1: '个体商户提交资料必须包含经营者亲笔签名及对应身份证号码；',
    auditPrompt2: '企业商户所有资质文件需加盖有效企业公章；',
    auditPrompt3: 'HURIX 货主服务合同内填写的企业名称、注册编号、增值税号必须与上传的企业/个体资质文件信息完全一致；',
    auditPrompt4: '若出现信息不匹配、企业文件无公章、个体资料缺少签名或身份证号任一情况，入驻申请将直接驳回。',
    Attachment: '附件',
    ShipperAccountStatus: '卖家账户状态'
  },
  message: {
    addedSuccessfully: '新增成功！',
    deleteSucceeded: '删除成功!',
    uploadFailed: '上传失败!',
    sendCode: '验证码发送成功!',
    operateSuccess: '操作成功!',
    parameterError: '参数错误!',
    loginSuccess: '登录成功!',
    operateFailed: '操作失败!',
    systemError: '系统错误!请联系管理员',
    information: '消息',
    deleteInformation: '您确定要删除这条数据吗？',
    deleteSelectedInformation: '您确定要删除选中的数据吗？',
    confirmInformation: '您是否要确认提交？',
    confirm: '确定',
    modifyStatus: '是否要修改该状态？',
    duplicatePhoneNumber: '手机号重复',
    phoneRequired: '请先填写手机号',
    emailRequired: '请先填写邮箱',
    WhetherTo: '是否要',
    classification: '这个分类',
    FileUploadFailure: '文件上传失败!',
    fileFormatIncorrect: '上传文件格式不正确!',
    exceedTenM: '文件大小不能超过10M!',
    fileTypeMustBeJPGOrPng: '文件必须为JPG或PNG或BMP!',
    copySuccessfully: '复制成功！',
    supportedMediaFormats: "仅支持上传图片及 m4v, mp4, mkv, mov, 3gp, webm 格式的视频!",
    pleaseSelectShelf: '请选择要结算的店铺!',
    uploadSuccessfully: '上传成功',
    noticeTitle: "提示",
    goodsShippedTip: "商品已出库/发货，请再次确认审批是否通过",
    orderCancelTip: "系统将取消 HURIX 订单并自动退款，请尽快通知仓库尝试拦截快递",
    hasUnverifiedOrdersTip: '存在未对账订单，请对账后重试',
    enterCode: '输入验证码',
    resetPwdTip: '已有账号？',
    signUpNow: '立即登录',
  },
  rulesTips: {
    required: '此字段为必填项。',
    emailTips: '请输入有效的电子邮件地址',
    correctPhoneEmailNumber: '请输入有效的手机号或邮箱地址',
    enterChar: '输入3个或更多字符',
    enterPasswordAgain: '请再次输入密码',
    passwordInconsistent: '两次输入密码不一致！',
    noSpace: '不能包括空格',
    passwordLength: '长度为 8 到 20 位字符',
    passwordComplexity: '必须包含大写字母、小写字母、数字、符号中至少3种',
    max35Characters: '输入内容不能超过35个字符',
    twoToOneHundredAndForty: '输入长度限制在2到140个字符之间',
    requiredFields: '必填项不能为空！',
    loginAgain: '此操作会让您强制退出，重新登陆系统',
    enterMore: '请至少输入两个字符',
    postcodeTip: '邮编格式不正确，正确示例: SW1A 1AA',
    correctPhoneNumber: '请输入正确的手机号格式',
    emailNotRegistered: '该邮箱未注册',
    phoneNumberNotRegistered: '该手机号未注册',
    fileSizeLess10: '文件需<10MB',
    changeTime: '变更时间',
    previousStatus: '原状态',
    currentStatus: '状态',
    withdrawStatusCollection: '提现进度',
    withdrawStatus: '提现状态',
    withdrawFailReason: '提现失败原因',
    withdrawStatus1: '提现申请中',
    withdrawStatus2: '余额充值中',
    withdrawStatus3: '结汇审核中',
    withdrawStatus4: '提现中',
    withdrawStatus5: '提现成功',
    withdrawStatus6: '提现失败',
    refundAmount: '请输入退款金额'
  },
  home: {
    index: '排名',
    pendingShelf: '待审核卖家',
    pendingProduct: '待审核商品',
    pendingOrder: '待审核订单',
    pendingWarehouse: '待审核仓库',
    orderReview: '订单总览',
    orderSum: '订单数量',
    settleOrderSum: '已结算订单数',
    OrderReceived: '待收货',
    pendingPaymentOrder: '待支付订单',
    pendingDeliveryOrder: '待发货',
    shippedOrders: '已发货订单',
    completedOrder: '已完成订单',
    productReview: '商品总览',
    allProducts: '商品数量',
    listing: '已上架',
    delisting: '已下架',
    inventoryShortage: '库存紧张',
    quickEntrance: '快捷入口',
    commodityInventory: '库存低于10',
    inventoryAlert: '库存预警',
    orderInformation: '订单信息',
    quantityOfGoods: '商品数目',
    remainingInventory: '剩余库存',
    settlementAmount: '历史收益',
    newbieTask: '新手任务：发布商品',
    checkTutorial: '查看教程',
    title: '恭喜您完成新店注册。为了更好地享受HURIX的销售优势，请尽快发布您的产品。',
    publishNow: '立即发布',
    newlyAddedProduct: '新增商品',
    priceDeclaration: '价格申报',
    officialSale: '正式开售',
    deliverToConsumers: '发货到消费者',
    returnReview: '退货审核',
    pendingAfterSales: '待处理售后',
    cancelOrderPending: '取消订单待处理',
    logisticsException: '物流异常',
    pendingViolation: '待处理违规',
    operatingData: '运营数据',
    realTime: '实时',
    last7Days: '近7天',
    last30Days: '近30天',
    moreData: '更多',
    transactionAmount: '成交金额',
    transactionVolume: '成交订单量',
    numberOfCustomers: '成交人数',
    productVisitors: '商品访客数',
    productClicks: '商品点击数',
    refundOrders: '退款订单',
    storeExpenditure: '店铺支出金额',
    withdrawAmount: '可提现金额',
    withdraw: '提现',
    yesterday: '昨日',
    flat: '持平',
    registerTrend: '卖家与买家注册趋势（30天）',
    realTimeOrderAmount: '实时单成交金额',
    realTimeOrderVolume: '实时单成交订单量',
    realTimeOrderCustomers: '实时单成交人数',
    reservationOrderAmount: '预约单成交金额',
    reservationOrderVolume: '预约单成交订单量',
    reservationOrderCustomers: '预约单成交人数',
    estimated: '预估待结算金额',
    productsExpiringSoon: '商品即将到期',
    outstandingPaymentSettlement: '结算欠款金额',
    lowRatedProductsCount: '商品低评分数',
    unconfirmedReceipts: "未确认收货",
    productsOnHold: "预定中",
    afterSalesPending: "售后审核中",
    alipayOrderVolume: "支付宝支付订单量",
    wechatOrderVolume: "微信支付订单量",
    bankcardOrderVolume: "银行卡支付订单量",
    salesRepData: "销售代表推荐数据统计",
    statisticalPeriod: "统计周期：",
    priceDistribution: '订单金额占比',
    peopleDistribution: '人数占比',
    leftSemicircle: '左半圆',
    rightSemicircle: '右半圆',
    distributor: '分销商',
    shipper: '卖家',
    detailedData: '详细数据',
    failedToGetPeoplePieData: '获取推荐总人数饼图数据失败',
    failedToGetPricePieData: '获取专属链接统计饼图数据失败',
    distributorOrderTotal: '分销商订单总金额',
    shipperOrderTotal: '卖家下单总金额',
    salesRepresentative: '销售代表',
    salesPerformance: '销售业绩',
    numberOfReferrals: '推荐人数',
    clickToViewDetails: '点击可查看详细信息',
    people: '人',
    dashboardTitle: '实时业务监控 · 数据驱动决策',
    lastUpdateTime: '最后更新时间',
    report: '报表',
    loading: '加载中...',
    operationalPending: '运营待处理',
    financePending: '财务待处理',
    buyerBalanceApply: '分销商余额申请',
    sellerBalanceApply: '卖家余额申请',
    orderTradeTrend: '订单量趋势',
    gmvTrend: 'GMV趋势分析',
    userRegisterTrend: '用户注册趋势',
    paymentChannelShare: '支付渠道占比',
    alipayPay: '支付宝支付',
    wechatPay: '微信支付',
    bankCardPay: '银行卡支付',
    tooltipPendingShelf: '待审核的卖家入驻申请数量',
    tooltipPendingProduct: '待审核的商品SPU数量',
    tooltipPendingWarehouse: '待审核的仓库入驻申请数量',
    tooltipPlatformIntervention: '售后纠纷中已发起平台介入处理的订单数量',
    tooltipOutstandingPaymentSettlement: '已到结算周期，尚未完成回款的欠款总金额',
    tooltipEstimatedSettlement: '已成交未到结算周期，预计后续待结算金额',
    tooltipBuyerBalanceApply: '提现、复购退款、预订单释放、定金退款、到期退款',
    tooltipSellerBalanceApply: '提现、平台结算',
    seriesRealtimeOrder: '实时单订单量',
    seriesPreOrder: '预订单订单量',
    seriesDistributorChannel: '分销商渠道订单量',
    seriesNgtChannel: 'NGT渠道订单量',
    seriesRealtimeGmv: '实时单GMV',
    seriesPreGmv: '预订单GMV',
    seriesDistributorGmv: '内部订单GMV',
    legendNgtChannelGmv: '非内部订单GMV',
    seriesNgtGmv: 'NGT渠道GMV',
    legendRealtime: '实时单',
    legendPreOrder: '预订单',
    legendDistributorChannel: '分销商渠道',
    legendNgtChannel: '非内部订单',
    shipperTotal: '卖家总数',
    distributorTotal: '分销商总数',
    spuCategory: 'SPU品类',
    lowStockSku: '低库存SPU',
    statisticsDetailTitle: '统计明细数据',
    statisticsDetailSubTitle: '多维度经营数据看板，助您掌握订单趋势、GMV变化、用户增长、支付结构及销售代表绩效，为运营与决策提供数据支撑。',
    dateRangeSep: '~',
    query: '查询',
    export: '导出',
    querySuccess: '查询成功',
    exportSuccess: '导出当前表格数据成功！',
    colDate: '日期',
    colTotal: '合计',
    colShipperRegister: '卖家注册',
    colDistributorRegister: '分销商注册',
    colPeriod: '周期',
    colAlipay: '支付宝',
    colWechat: '微信',
    colBankCard: '银行卡',
    colAlipayRate: '支付宝占比',
    colWechatRate: '微信占比',
    colBankCardRate: '银行卡占比',
    colShipperOnboard: '卖家入驻数量',
    colShipperOrderAmountMonthly: '日订单金额（卖家）',
    colDistributorOnboard: '分销商入驻数量',
    colDistributorOrderAmountMonthly: '日订单金额（分销商）'
  },
  product: {
    physicalGoods: '实物商品',
    importProductTemplate: '商品模板导入',
    retailInfo: '零售批发，物流配送',
    templateInfo: '商品模板，一键导入',
    selectProductType: '请选择商品类型',
    basicInfo: '基本信息',
    commodityTradingInfo: '商品交易信息',
    productSpecification: '商品规格及图片',
    productDesc: '商品详情',
    productLogisticsInfo: '商品物流信息',
    otherInfo: '其他信息',
    category: '商品分类',
    price: 'HURIX售价',
    weight: '商品重量',
    dimensions: '商品尺寸',
    quantity: '库存',
    referencePrice: '市场参考价（含税）',
    referenceLink: '参考链接',
    profit: '折扣率（相对市场参考价）',
    productName: '商品名称',
    listingStatus: '上架状态',
    productImage: '商品图片',
    stock: '库存',
    productStock: '商品库存',
    verifyStatus: '审核状态',
    pendingApproval: '待审核',
    reviewRejected: '审核驳回',
    productVerifyTitle: '商品审核',
    selectProductCategory: '选择商品品类',
    fillInProductDetails: '填写商品详情',
    products: '商品',
    TotalProductPrice: '商品总价',
    total: '总计',
    productReleaseSuccessful: '商品发布成功',
    publishedSuccessfullyMsg: '恭喜您，商品发布成功!',
    viewProductStatus: 'Go check the product review status',
    youCanAlso: 'You can also',
    goOn: 'Go on',
    publishProduct: '发布商品',
    productPrice: '商品价格',
    sellingPoint: '商品卖点',
    productBrand: '商品品牌',
    brandName: '品牌名称',
    brandIcon: '品牌图标',
    unit: '销售单位',
    hostGraph: '主图',
    uploadFile: '上传文件',
    fileToWithin10MB: '请压缩文件在10M以内',
    customSpecificationItems: '自定义规格项',
    addSpecificationItems: '添加规格项',
    specificationItem: '规格项',
    addSpecificationImages: '添加规格图片',
    specificationValue: '规格值',
    specificationName: '规格名称',
    detailedSpecifications: '规格详细',
    verifyMaterials: '审核材料',
    productInfoVerifyTip: '请提供库存证明材料，以确保商品信息的真实性与可用性',
    previousStep: '上一步',
    saveProduct: '保存商品',
    saveDraft: '保存草稿',
    reason: '原因',
    pass: '通过',
    refuse: '拒绝',
    editInventory: '编辑库存',
    editProductInformation: '编辑货品信息',
    skuNumber: 'SKU Number',
    sellingPrice: '销售价格',
    selling: '售卖中',
    soldOut: '已售罄',
    addBrand: '新增品牌',
    reasonForRejection: '驳回原因',
    brandLogo: '品牌Logo',
    classificationName: '分类名称',
    editCategory: '编辑分类',
    addCategory: '添加分类',
    defaultIcon: '默认图标',
    selectIcon: '选中图标',
    categoryParent: '上级分类',
    categoryDrawerTip: '新增、编辑分类与添加子分类共用同一套表单结构',
    categoryInfo: '分类信息',
    categoryInfoTip: '用于分类名称与层级关系维护',
    categoryIconConfig: '分类图标',
    categoryIconTip: '分别配置默认状态与选中状态图标',
    categoryRequiredTip: '带 * 为必填项',
    expirationDate: '到期时间',
    localTimeAtWarehouse: '仓库所在地时间',
    bindWarehouse: '绑定仓库',
    addAndBindWarehouse: '新增仓库',
    businessType: '业务类型',
    warehouseInfo: '托管库存',
    list: '上架',
    delist: '下架',
    notFindBrand: '找不到相关品牌吗？ 去添加',
    enterYourReviewResult: '审核结果',
    productCommissionByThePlatform: '平台佣金比例',
    spu: '商家SPU',
    shipperSku: '商家SKU',
    supportFiveFiles: '最多支持上传5个文件',
    isAutoList: '审核通过即上架',
    canBeReturned: '买家退货',
    carrier: '物流商',
    transitTime: '快递时效',
    weightLimit: '重量限制',
    basicFreight: '基础运费',
    surcharge: '附加费',
    auditReminder: '商品关联仓库待审核，请先完成审核',
    WarehouseAddress: '仓库地址',
    isSplit: '是否支持分箱≤30kg',
    AvailableStock: '可用库存',
    ConfirmTakeOffline: '是否确认下架',
    documentProofs: '文件证明',
    customsDeclaration: '海关报关单',
    purchaseInvoice: '商品采购发票',
    warehouseEntryVoucher: '海外仓入库证明',
    certificateOfGoods: '委托仓货物证明',
    brandAuthorizationLetter: '品牌授权书',
    taskName: '任务名称',
    taskStatus: '任务状态',
    taskResultDescription: '任务结果描述',
    uploading: '解析中',
    parsingSuccessful: '解析成功',
    parsingFailed: '解析失败',
    partiallySuccessful: '部分成功',
    settlementTask: '结算任务',
    reconciliationTask: '对账任务',
    taskList: '任务列表',
    taskRecords: '任务记录',
    taskTotal: '任务总数',
    pageSuccess: '本页成功',
    pageFail: '本页失败',
    successfulTasks: '解析成功',
    failedTasks: '失败任务',
    taskRecordCount: '共 {count} 条任务记录',
    settlementTaskSubtitle: '查看最近批量结算任务的执行状态与解析结果',
    reconciliationTaskSubtitle: '查看最近批量对账任务的执行状态与解析结果',
    batchSettlement: '批量订单结算',
    batchReconciliation: '批量对账',
    viewReconciliationTask: '查看对账任务',
    viewSettlementTask: '查看结算任务',
    shipping: '运输',
    isShippingFree: '是否包邮',
    packageWeight: '包裹重量',
    packageDimensions: '包裹尺寸',
    estimatedShippingCost: '预估运费',
    shippingNotes: '大陆地区包括英格兰、威尔士和苏格兰，偏远地区则指北爱尔兰和苏格兰高地。计算卖家类别时，我们会同时考虑取件和送件量;但送件包裹将始终按照送件费率表收费。',
    remoteAreas: '偏远地区包括以下地区',
    consigneeInformation: '收/发货人信息',
    tradeLegalityDesc: '进口商品（需含商品编码、清关日期、卖家名称、税务缴纳情况等）',
    originAuthenticityDesc: '采购商品（需含VAT编号、采购方与卖家一致）',
    inventoryExistenceDesc: '第三方海外仓托管商品（需显示入库时间、SKU编码、卖家名称）',
    goodsAuthenticityDesc: '出具方仓库的官方联系方式、证明编号、货物明细',
    ipComplianceDesc: '代理/分销品牌商品（需品牌方盖章及授权有效期）',
    isReturnableTips: '设置商品是否支持退货，影响买家的购买决策',
    estimatedShippingCostTips: '预估运费提示',
    packageDimensionsTips: '包裹尺寸是指商品包装后的长宽高，影响物流费用计算和运输方式选择',
    packageWeightTips: '包裹重量是指商品包装后的总重量，影响物流费用计算',
    isSplitTips: '是否支持将商品分多个包裹发货，适用于大件商品',
    autoShelvesTips: '审核通过后是否自动上架商品，节省操作时间',
    detailsTips: '商品详情是向买家展示商品特点和优势的重要内容，建议详细填写',
    fillInSpec: '填写规格',
    fillInSpecTips: '规格项是商品的基本属性，如颜色、尺寸等，用于区分不同的SKU。<br>规格值是规格项的具体内容，如红色、蓝色、M码、L码等。',
    hostGraphTips: '宽高比：1:1。文件大小上限：10 MB。格式：JPG/PNG/GIF。尺寸：800×800px',
    spuTips: 'SPU 为商品统一标识，建议填写商家内部商品编码，用于商品统一管理、库存追踪及多规格商品归类。',
    dimensionsTips: '填写商品的实际尺寸，包括长度、宽度和高度，单位为厘米(cm)，确保尺寸信息准确，避免物流问题',
    weightTips: '填写商品的实际重量，单位可以选择克(g)或千克(kg)，确保重量信息准确，避免物流问题',
    brandTips: '填写商品的品牌名称，确保品牌信息准确无误，有助于建立品牌形象和提高商品可信度',
    categoryTips: '选择正确的商品分类，有助于买家快速找到您的商品，提高曝光率和转化率',
    sellingPointTips: '突出商品的核心优势和独特卖点，吸引买家注意力，促进转化，不超过500个字符',
    productNameTips: '清晰准确描述商品，包含核心属性和特点，使用简洁明了的语言，不超过255个字符',
    documentProofsTip: '卖家必须提供以上至少一项文件证明。每项最多5个文件，单文件≤10M',
    specTips: '至少需要添加一个规格项，每个规格项下至少需要添加一个规格值，第一个规格项下的每个规格值必须上传对应图片，最多支持添加五个规格项。',
    recommendedCategories: '推荐分类',
    selectCategory: '选择分类',
    basicInfoTips: '填写商品的基本信息，包括名称、卖点、分类、品牌、重量、尺寸等核心属性，确保信息准确完整，有助于商品曝光和转化',
    Reservation: '预订',
    buyNow: '立即购买',
    cumulativeEvaluation: '累计评价',
    profitable: '盈利',
    imageCropping: '图片裁剪',
    inventoryAdjustmentWarning: '库存调整警告',
    warehouseNameTips: '选择商品存储的仓库，确保库存信息准确',
    referenceLinkTips: '参考链接用于验证商品价格，建议填写主流电商平台的商品链接',
    requiredToProvideMarketPrice: '需要提供市场价格',
    supplyPrice: '供货价',
    supplyPriceExplain: '全托管合同签署价',
    platformPriceExplain: '平台价格说明',
    priceAndStock: '价格和库存',
    createValue: '创建价值',
    noOption: '无选项',
    createType: '创建类型',
    linkOtherWarehouse: '关联其他仓库',
    noWarehouseFound: '未找到仓库',
    auditSection: '审批操作',
    auditResult: '审批结果',
    auditMessage: '审批意见',
    approve: '同意',
    reject: '拒绝',
    submitAudit: '提交审批',
    rejectMessageRequired: '请输入拒绝原因',
    auditMessagePlaceholder: '请输入审批意见（选填）',
    quickBooksAuthorization: 'QuickBooks 授权',
    productDetailTitleMod: '加粗为改，',
    productDetailTitleDel: '划去为删',
    productDetailTitleDelComma: '，',
    productDetailTitleVerify: '请核实所有变更项',
    sameCategoryDetect: "检测到同名分类",
    pendingCategoryInfo: "本次待提交分类信息",
    fullCnPath: "中文完整路径",
    fullEnPath: "英文完整路径",
    existSameCategoryTip: "系统中已存在以下同名分类",
    tipSameCategory: "提示：系统存在同名分类，点击确认添加仍可创建",
    backEditBtn: "返回编辑",
    confirmAddBtn: "确认添加",
    autoApproveProduct: '是否开启自动审核商品',
    productReviewSettings: '商品审核配置',
    productVat: "商品增值税",
    shippingVat: "运费增值税",
    pendingApprovalDesc: '系统审核完成后将自动更新状态',
  },
  order: {
    order: '订单',
    orderSn: '订单号',
    orderNumber: '订单编号',
    buyerName: '买家名称',
    buyer: '分销商',
    seller: '卖家',
    consignee: '收货人',
    buyerContact: '买家手机号/邮箱',
    orderTime: '下单时间',
    orderStatus: '订单状态',
    startDate: '开始日期',
    endDate: '结束日期',
    orderAmount: '订单金额',
    paymentMethod: '支付方式',
    viewOrder: '查看订单',
    PendingPayment: '待支付',
    toBeConfirmed: '待确认',
    pendingShipment: '待发货',
    partialShipment: '部分发货',
    inTransit: '运输中',
    shipped: '已发货',
    ReservationInProgress: '预订中',
    PreOrderInProgress: '预订中',
    completed: '已完成',
    closed: '订单关闭',
    OrderCompleted: '已完成',
    OrderClosed: '已关闭',
    Cancelled: '已取消',
    alipay: '支付宝',
    wechat: '微信',
    unpaid: '未支付',
    orderLog: '订单日志',
    cancellationOfOrder: '取消订单',
    CancellationReason: '取消原因',
    addANote: '添加备注',
    country: '国家/地区',
    city: '城市/城镇',
    logisticsInformation: '配送信息',
    orderDetails: '订单详情',
    syncLogistics: '同步物流',
    noSyncLogisticsToThirdParty: '无需同步物流至三方',
    receiptInformation: '配送至',
    orderNotes: '订单备注',
    invoiceInformation: '发票信息',
    noInvoiceInformation: '未提供发票信息',
    specifications: '规格',
    number: '数量',
    subtotal: '小计',
    totalAmount: '商品总价',
    recipient: '收件人',
    recipientRegion: '收件地区',
    detailedAddress: '详细地址',
    shippingAddress: '收货地址',
    postcode: '邮编',
    shipmentQuantity: '发货数量',
    noLogisticsInformation: '暂无物流信息',
    deliveryTime: '发货时间',
    trackingNumber: '发货单号',
    logisticsCompany: '承运商',
    logisticsStatus: '物流状态',
    platformHandlingFee: '平台服务费',
    ReservationInformation: '预订信息',
    ReservationPeriod: '预订周期',
    priceModel: '价格模式',
    NumberOfReservations: '预订数量',
    confirmModifyRemarksOrder: '您确定要修改备注订单',
    sureCancelOrder: '确定要取消订单吗? 请输入你的取消原因',
    realTimeOrder: '实时单',
    ReservationOrder: '预订单',
    lockPriceModel: '锁价模式',
    noLockPriceModel: '不锁价模式',
    days: '天',
    proportionOfDeposit: '订金比例',
    amountOfDeduction: '抵扣金额',
    deposit: '订金',
    NotYetCreated: '未创建',
    AwaitingReceipt: '待收货',
    waitBuyerShip: "待买家发货",
    waitSellerReceive: "待卖家收货",
    ReservationCompleted: '预订完成',
    PreOrderCompleted: '预订完成',
    RemainingReservableQuantity: '剩余预订数量',
    PolicyNumber: '保险单号',
    InsuranceCompany: '保险公司',
    PolicyStatus: '保单状态',
    AmountInsurance: '保险费金额',
    AmountCompensation: '赔付金额',
    InEffect: '生效中',
    failure: '失效',
    undo: '撤销',
    ClaimsProgress: '理赔中',
    CompensationComplete: '已赔偿',
    Terminate: '终止',
    Frozen: '冻结',
    state: '州/省',
    InRefund: '退款中',
    RefundSuspension: '退款挂起',
    RefundSuccessful: '退款成功',
    RefundFailure: '退款失败',
    InRefundLog: '您的商品正在退款中，请耐心等待',
    RefundSuspensionLog: '账户余额不足，退款被挂起',
    RefundCompletedLog: '您的商品退款成功',
    RefundFailureLog: '您的商品退款失败',
    insufficientStockReservation: '商品库存不足，预订取消并退款',
    refund: '退款',
    created: '已创建',
    enterReasonRefund: '请输入退款原因',
    createdLog: '您的订单已创建',
    toBeConfirmedLog: '您的订单已成功提交，我们正在为您处理订单，请稍后',
    PendingPaymentLog: '您的订单已确认，现在您可以进行付款',
    pendingShipmentLog: '我们已收到您的付款，商品正在准备发货中',
    partialShipmentLog: '您的部分商品已经发货，剩余商品将尽快发出',
    InTransitLog: '您的商品已全部发货，正在运输中',
    WaitToBeReceivedLog: '您有商品已到目的地，请及时取件',
    completedLog: '您的订单已完成，感谢您的购买',
    ReservationInProgressLog: '预订中(等待履约)',
    ReservationCompletedLog: '所有预订商品已购买，预订单结束',
    closedLog: '支付超时,系统取消订单',
    CancelledLog: '您的订单已被取消',
    RefundLog: '退款日志',
    RefundAmount: '退款金额',
    TotalRefundAmount: '退款总额',
    RefundStatus: '退款状态',
    ReservationDeductionAmount: '预订抵扣',
    BuyerPaid: '买家已付',
    PlatformRevenue: '成交后平台收益',
    commodityInformation: '商品信息',
    InitiatePurchase: '发起购买',
    cancelPurchase: '取消购买',
    CommodityQuantity: '商品数量',
    paymentId: '支付流水号',
    level: '等级',
    ReturnRequestNo: '退货请求 #',
    ReturnLog: '退货日志',
    createdReturn: '退货申请已成功创建',
    toBeConfirmedReturn: '退货申请提交成功，处理中',
    pendingShipmentReturn: '退货申请已通过，请尽快发货并填写物流信息',
    inTransitReturn: '退货商品已发出，运输中',
    AwaitingReceiptReturn: '退货商品已送达指定地址',
    completedReturn: '退货流程完成，进入退款阶段',
    reviewRejectedReturn: '卖家拒绝申请，退货流程终止',
    CancelledReturn: '退货申请已取消，退货流程关闭',
    returnInformation: '退货信息',
    returnReason: '退货原因',
    addReturnReason: '新增退货原因',
    editReturnReason: '编辑退货原因',
    returnVerificationPhotos: '退货验证照片',
    returnList: '退货列表',
    returnStatus: '退货状态',
    returnTime: '退货时间',
    reservationExpired: '预订超期',
    reservationRefunded: '退还预订金',
    BreachPenalty: '惩罚金',
    penaltyChargeTip: '超期未完成预订或者取消预订就会产生惩罚金',
    Returned: '发生退货',
    returnAddress: '退货地址',
    returnDetails: '退货详情',
    breachQuantity: '违约数量',
    purchasableQuantity: '可购买数量',
    refundDetails: '退款详情',
    refundReason: '退款原因',
    refundTransaction: '退款流水号',
    all: '全部',
    RefundsReturns: '退货与退款',
    returnOccurs: '退货',
    refundHappens: '发生退款',
    purchasableQuantityReduce: '商品库存不足，可购买数量减少refundQuantity',
    releaseQuantityRefunded: '商品库存不足导致退款，退款数量：refundQuantity',
    ReturnId: '退货编号',
    returnRecords: '退货记录',
    refundRecords: '退款记录',
    shippingParty: '发货物流承担方',
    returnShippingParty: '退货物流承担方',
    credential: '凭证',
    afterConfirmingReceipt: '确认收货后，相应的款项将退还给买家。',
    negotiationHistory: '沟通记录',
    ReturnRequestSubmitted: '发起了退货申请',
    ReturnRequestApproved: '退货申请审核通过',
    buyerHasShipped: '买家已发货',
    ReceiptConfirmedSeller: '卖家已确认收货',
    ReturnRequestRejected: '退货审核被驳回',
    ReturnRequestCancelled: '取消了退货申请',
    notes: '备注',
    RefundType: '退款类型',
    RequestPlatformIntervention: '申请平台介入',
    PlatformIntervention: '平台介入',
    PlatformProcessing: '平台处理中',
    PlatformAdjustsReturnStatus: '平台调整退货状态',
    Arbitration: '仲裁',
    ReturnLogisticsPayer: '退货物流承担方',
    UpdateReturnStatus: '调整退货状态',
    senderAddress: '发货人地址',
    arbitrationResult: '仲裁结果',
    ShippingLogisticsCostBearer: '发货物流费用承担方',
    ReturnLogisticsCostBearer: '退货物流费用承担方',
    ReturnAndRefundSupported: '支持退货退款',
    ReturnsRefundsNotSupported: '不支持退货退款',
    MaximumReservation: '最大预订周期',
    CreditCard: '银行卡',
    OrderTotal: '订单总计',
    orderTotalSubVat: '不含税订单金额',
    RefundOnly: '仅退款',
    PartyLiableShipment: '发货运费承担方',
    PartyLiableReturn: '退货运费承担方',
    shipmentTotalMoney: '发货运费总额',
    returnTotalMoney: '退货运费总额',
    estimated: '预估',
    refundOnlyTip: '仅退款支持调整退款金额，建议您仔细核对后修改，减少不必要的纠纷',
    currentRefundAmount: '本次退款金额',
    defaultFullRefundEditable: '默认全额退款，可修改',
    buyerRefundableTotal: '买家可退总额',
    refundAmountCannotExceed: '退款金额不能超过可退总额',
    enterRefundAmount: '输入退款金额',
    ReturnLogisticsCompany: '退货承运商',
    CardPaymentHandlingFee: '支付手续费',
    refundFee: '退款手续费',
    refundFeeRule: '若发生退款，每笔将收取固定手续费num',
    balance: '余额',
    ShipFree: '包邮',
    AllOrders: '全部订单',
    requiredToShip: '24h需发货',
    OvertimeShipped: '超时未发货',
    LogisticsTrackingNumber: '物流单号',
    LastDay: '最近一天',
    LastDay7: '最近一周',
    LastDay30: '最近一个月',
    LastDay90: '最近三个月',
    sellerContact: '卖家手机号/邮箱',
    unitPrice: '单价',
    AfterSalesStatus: '售后状态',
    None: '暂无',
    PromiseShip: '请在',
    PromiseShip2: '内确认发货',
    autoCancelTip: "", // 有用别删
    autoCancelTip2: "后自动取消订单，请及时发货",
    timedOutStatus: '00:00:00',
    ShippingInformation: '收货信息',
    LogisticsUpdates: '物流动态',
    BuyerPlacesOrder: '买家下单',
    PaymentSuccessful: '付款成功',
    MerchantShipsGoods: '商家发货',
    TransactionCompleted: '交易完成',
    orderType: '订单类型',
    paymentTime: '付款时间',
    BuyerInformation: '买家信息',
    BuyerRemarks: '买家备注',
    BuyerNickname: '买家昵称',
    DeliveryInformation: '配送信息',
    DeliveryMethod: '配送方式',
    LogisticsDelivery: '物流配送',
    OtherInformation: '其它信息',
    PurchaseSource: '购买来源',
    WebVersion: '网页版',
    returnWindowCloseAfter: '退货窗口关闭时间',
    InsuranceInformation: '保险信息',
    RequestTime: '申请时间',
    cancelHasBeenInitiated: '发起了取消订单申请',
    labelGenerationStatus: '快递面单生成状态',
    labelGeneratedSuccess: '生成成功',
    labelGenerating: '生成中',
    labelGeneratedFailed: '生成失败',
    GeneratingLabel: '退货面单生成中',
    returnShippingLabelGenerating: '退货快递面单生成中',
    consigneeEmailOrPhone: '收货人手机号/邮箱',
    thirdPartyOrders: '第三方订单',
    tiktokOrders: 'TikTok订单',
    temuOrders: 'Temu订单',
    amazonOrders: 'amazon订单',
    shopifyOrders: 'shopify订单',
    afterSaleRecordsTip: 'num条售后记录，点击查看',
    hours: '小时',
    minutes: '分钟',
    orderOrtThirdParty: '请输入订单编号或第三方订单编号',
    returnHasClosed: '退货窗口已关闭',
    confirmReceipt: '确认收货',
    isConfirmReceipt: "是否确认收货",
    ConfirmReceiptSuccess: '确认收货成功',
    salesRepresentative: '销售代表',
    arbitrationDescription: '请填写仲裁结果及相关信息',
    logisticsCostInfo: '物流费用信息',
    uploadTip: '支持上传图片格式，最多5张，单张不超过10MB',
    pushOrderToWarehouse: "推送到仓库",
    confirmPushOrderTip: "是否确认推送订单到仓库？",
    uploadBill: "上传账单",
    settleUploadExcelTip: "全托管店铺结算需上传账单excel",
  },
  logistics: {
    shippingCost: '运费',
    deliveryType: '配送类型',
    standardSingleParcel: '‌普运单包',
    expressSingleParcel: '速运单包',
    multipleParcels: '多包裹',
    weightLimit: '‌重量限制',
    perParcel: '单个包裹',
    transitTime: '‌时效',
    businessDays: '工作日',
    BaseShippingCost: '基础运费',
    Surcharge: '附加费',
    SeparateRates: '独立计费',
    remoteAreas: '偏远地区 +',
    remoteArea: '偏远地区',
    MultiParcelFee: '多包裹费用',
    chargeableWeight: '计费重量‌',
    AddressLine1: '‌地址行 1',
    AddressLine2: '‌地址行2',
    AddressLine: '地址行',
    shippingBillingRules: '运费计费规则',
    remoteAreaNoFreeShipping: '偏远地区不包邮',
    billingWeightComparisonTable: '计费重量对照表',
    billingWeightComparisonTableRemoteArea: '计费重量对照表（偏远地区）',
    isRemoteArea: '是否偏远地区？',
    yesOption: '是',
    noOption: '否',
    UKMainland: '英国本土',
    UnitedKingdom: '英国',
    China: '中国',
    standardRate: "标准费率",
    ladderBilling: "阶梯计费",
    currentBilling: "本次计费",
    estimatedDeliveryText: "预计3-7个工作日送达",
    earliestShipTip: "预计最早于24点之前发货",
  },
  template: {
    name: '模板名称',
    content: '模板内容',
    siteMessageTemplate: "站内信模板",
    emailTemplate: "邮件模板",
    settlementTemplate: "结算模板",
    drawerSubtitle: '配置模板基础信息与消息内容',
    basicInfo: '基础信息',
    basicInfoTip: '维护模板编号、名称和业务类型',
    contentTip: '支持 HTML 与变量占位符',
    messageContent: '消息内容',
    contentPlaceholder: '请输入消息内容，支持 HTML 与变量占位符',
    requiredTip: '带 * 为必填项',
  },
  settings: {
    bind: '绑定',
    bindBrand: '绑定品牌',
    bindSpec: '绑定规格',
    bindParams: '绑定参数',
    associateBrand: '关联品牌',
    categoryLevel: '分类级别',
    primaryClassification: '一级分类',
    addSubcategory: '添加子分类',
    optionalValues: '选项值',
    parameter: '参数',
    parameterGroup: '参数组',
    noParameter: '暂无参数绑定信息',
    warehouseCode: '仓库编码',
    warehouseName: '仓库名称',
    warehouseSystem: '仓库系统',
    warehouseAlias: '仓库别名',
    address: '地址',
    countryCode: '国家',
    city: '城市/城镇',
    email: '邮箱',
    addWarehouseDic: '新增仓库',
    editWarehouseDic: '编辑仓库',
    warehouseDrawerSubtitle: '填写仓库基础地址信息，用于订单及物流业务匹配。',
    warehouseBasicInfo: '基础信息',
    warehouseAddressInfo: '地址信息',
    warehouseAddressHint: '街道、门牌号等',
    optional: '选填',
    deliveryInfoSubtitle: '查看当前仓库在英国本土与偏远地区的配送收费规则。',
    applicableWarehouse: '适用仓库',
    deliveryCurrency: '币种',
    deliveryUpdatedAt: '更新时间',
    viewRemotePostcodeRange: '查看偏远地区邮编',
    remotePostcodeTitle: '偏远地区',
    remotePostcodeDescription: '服务中心及本地地区对应的邮编区域明细',
    remotePostcodeTip: '下表用于说明英国偏远地区判定范围，邮编命中以下区域时，将按偏远地区运费规则计费。',
    warehouseEmail: '仓库邮箱',
    warehouse: '仓库',
    postCode: '邮编',
    warehouseInfo: '仓库信息',
    basicOrderRules: '订单基础规则',
    maximumOrderAmount: '‌最高订单金额限制',
    minimumOrderAmountLimit: '最低下单金额限制',
    PaymentValidityPeriod: '支付有效期',
    MinimumUnitPrice: '最低预订单价',
    confirmRuleModification: '是否确认修改订单配置规则？',
    confirmSellerRuleModification: '是否确认修改卖家收费规则？',
    seconds: '秒',
    freightOwnerFeePolicy: '卖家收费规则',
    settlementCycle: '结算周期配置',
    platformSalesCommission: '平台按交易额百分比收取的服务费比例',
    platformFee: '平台费用',
    storeRentalFee: '店租',
    storageHostingFee: '仓储托管费(£/件/月)',
    returnLossFee: '退货损耗费(£/包裹)',
    packagingLaborFee: '包装&人工费(£/包裹)',
    entryMode: '入驻模式',
    selfManagement: '自营卖家',
    hurixSelfManagement: 'HURIX自营',
    fullyManaged: '全托管卖家',
    storeFee: '首年免收，次年按自然月计费',
    settlementHandlingFee: '结算手续费',
    paymentServiceCharge: '支付手续费',
    refundServiceCharge: '退款服务费',
    thirdPartyFee: '第三方支付平台手续费',
    changeNotification: '变更提示',
    effectNextMonth: '您修改的收费项将于次月生效',
    specification: '规格',
    bindSpecification: '绑定规格',
    addSpecification: '新增规格',
    editSpecification: '编辑规格',
    specificationDetails: '规格详情',
    valueGrouping: '规格值分组',
    groupName: '组名称',
    totalValues: '规格值总数',
    inputAndPressEnter: '请输入规格值并按回车添加',
    inputTip: '提示：输入内容后按回车键可添加新规格值',
    deleteGroup: '确定删除该分组吗？',
    groupExists: '组名不能重复',
    returnLabel: '退货标签',
    returnLabelConfiguration: '退货标签配置',
    effectiveCurrentMonth: '当月生效值为: ',
    salesCommissionRate: '销售佣金(%)',
    salesCommissionRateTips: '平台方分佣比例',
    salesCommission: '销售佣金(£)',
    commissionFreePeriod: '启航免服期(月)',
    commissionFreePeriodTips: '自审核通过次日起算',
    commissionFreePeriodData: '启航免服期',
    fixed: '(£)',
    deductionAmount: '扣款金额',
    amountDue: '欠款金额',
    price: '价格',
    weightRange: '重量范围',
    britishMainland: '英国本土',
    months: '个月',
    general: '通用',
  },
  tableColumns: {
    operator: '操作人',
    time: '时间',
    currentState: '当前状态',
    creditValueBeforeChange: '变更前信用值',
    currentCreditValue: '当前信用值',
  },
  im: {
    searchForContacts: '搜索联系人',
    ChatLog: '对话记录',
    send: '发送',
    wouldLikeTalk: '您想聊点什么...',
    noMore: '没有更多了',
    imageFormat: '图片格式不符合要求,仅支持jpg、jpeg、png类型',
    withdraw: '撤回',
    platformMessage: '消息',
    Buyers: '买家',
    Sellers: '卖家',
    CustomerSupportGroup: '客服支持群',
    groupMembers: '群组成员',
    StartChat: '开始聊天',
    NoStoreObtained: '没有获取到卖家信息',
    mobileView: '手机视图',
    messageNotifications: '通知',
    batchReconciliation: '批量对账',
    batchSettlement: '批量结算',
    allMessages: '全部消息',
    connectionStatus: '连接已断开',
    csConnectionError: '连接已中断，请尝试重新连接',
    reconnectAction: '重新连接',
    noNotifications: '暂无通知',
    contactBuyer: "联系买家",
    noBuyerInfo: "没有获取到买家信息",
  },
  settlement: {
    settlementCycle: '结算周期',
    ReservationOrderNo: '预订单编号',
    payAmount: '应付金额',
    deductionType: '抵扣类型',
    CompleteTime: '完单时间',
    status: '结算状态',
    time: '结算时间',
    settlement: '结算',
    orderCreatedTime: '订单创建时间',
    returnToPendingSettlement: '返回',
    pendingSettlement: '待结算',
    delayedSettlement: '延期结算',
    isDelay: '是否延期',
    normal: '正常',
    settled: '已结算',
    orderNo: '订单号',
    settlementFailed: '结算失败',
    confirm: '您确认对当前订单进行结算吗？',
    tradingTime: '交易时间',
    platformTransactionId: '平台交易流水号',
    reconciliation: '对账',
    reconciliationStatus: '对账状态',
    myMoneyTransactionId: '外部交易流水号',
    transactionAmount: '平台交易金额(£)',
    outTransaction: '外部交易',
    outTransactionAmount: '外部交易金额',
    myMoneyFee: '外部手续费',
    myMoneyTax: '外部税费',
    platformReceivedAmount: '平台入账金额(£)',
    transactionType: '交易类型',
    reconciliationResult: '对账结果',
    discrepancyType: '差异类型',
    reconciliationTime: '对账时间',
    transactionDetails: '交易详情',
    transactionInfo: '交易信息',
    transactionInfoTip: '平台与外部交易基础信息',
    amountInfo: '金额信息',
    amountInfoTip: '本次交易金额构成',
    paymentReconciliationInfo: '支付与对账信息',
    paymentReconciliationInfoTip: '查看支付方式及当前对账结果',
    reconciliationDetailNote: '该笔交易已完成对账，平台与外部交易金额核对一致，对账结果为平账。',
    adjustmentAmount: '平账调整金额(£)',
    adjustmentRemark: '平账备注',
    adjustment: '平账',
    orderSnTooltip: '可输入多个订单号，使用逗号分隔',
    orderSnPlaceholder: '请输入订单号，多个订单请用逗号分隔',
    uploadReconciliationFile: '请上传对账文件',
    unreconciled: '未对账',
    reconciling: '对账中',
    completed: '对账完成',
    balanced: '平账',
    imbalanced: '失衡',
    overage: '长款',
    shortage: '短款',
    amountMismatch: '金额不符',
    restrictions: '支持xlsx/xls/csv文件，且不超过10MB',
    addCustomFee: '添加自定义费用',
    feeDetailList: '结算费用明细',
    uploadSettlementStatement: '上传结算账单Excel',
    customizeExpenseDetails: '自定义费用明细',
    feeCount: '共 {count} 项',
    noCustomFee: '暂无自定义费用',
    customFeePlaceholder: '费用名称',
    customFeeDescription: '费用描述',
    customFeeDescriptionPlaceholder: '请描述该费用',
    feeTitle: '费用标题',
    feeDescription: '费用描述',
    settlementImpact: '结算方式',
    deduct: '扣减',
    increase: '增加',
    feeTitleHint: '用于在结算单中识别该收费项。',
    feeDescriptionHint: '简要说明该费用的用途。',
    settlementImpactHint: '选择从结算款中扣减或增加该金额。',
    feeAmountHint: '仅输入正数金额。',
    settledTitle: '结算费用',
    uploadFileFormatTip: '文件格式支持 .pdf、.xlsx、.xls 和 .csv',
    platformAdvanceLogisticsFee: "退货运费(£)",
    shippingCostCompensation: "销售运费补偿(£)",
    ownerSettlementAmount: "结算金额(£)",
    estimatedSettlementAmount: "预计结算金额(£)",
    actualOrderAmount: "订单实际金额(£)",
    paymentAmount: "支付金额(£)",
    orderTransactionRecord: "订单流水",
    fileName: '文件名称',
    file: '文件',
    invoiceDrawerSubtitle: '查看结算周期内各店铺生成的结算单、对账单与平台发票文件',
    shopCount: '店铺数量',
    fileTotal: '文件总数',
    fileRecords: '文件记录',
    fileRecordSummary: '共 {shops} 个店铺，{files} 个结算文件',
    settlementStatement: '结算单',
    reconciliationStatement: '对账单',
    platformInvoice: '平台发票',
    invoiceFooterTip: '文件生成后可直接下载，用于结算归档、财务核对或开票留档。',
    downloadInvoice: '下载结算单',
    selectSettleCycle: '请选择结算周期',
    salesShippingTrackingNumber: '销售物流单号',
    shippingFee: '销售运费(£)',
    returnShippingTrackingNumber: '退货物流单号',
    totalProductPrice: '商品总价(£)',
    cardPaymentRefundFee: '退款手续费',
    amount: '金额',
    transferIn: '转入',
    withdrawal: '提现',
    repurchaseRefund: '复购退款',
    repurchase: '复购',
    transactionNo: '交易单号',
    balance: '余额',
    transactionSerialNo: '交易流水号',
    applySerialNo: '申请流水号',
    enterTransactionSerialNo: '输入交易流水号',
    bankCardNo: '银行卡号',
    bankAccountName: '银行账户名',
    bankName: '银行名称',
    branchCode: '支行代码',
    flowNo: '扣款流水号',
    outPaymentNo: '支付流水号',
    withdrawalRemark: '提现备注',
    copyCardNumber: '复制卡号',
    copyFailed: '复制失败',
    cardNumberCopied: '卡号已复制到剪贴板',
    completeCardNumber: '完整卡号',
    paymentChannelReconciliation: 'MyMoney对账',
    mobileReconciliation: '微信支付宝对账',
    cardReconciliation: 'Stripe对账',
    balanceReconciliation: '余额对账',
    balanceApplication: '余额申请',
    preOrderRelease: '预订单释放',
    preOrderDepositRefund: '预订单订金退款',
    preOrderExpiryRefund: '预订单到期退款',
    platformSubsidy: '平台补贴 - 绑卡',
    estimatedDebt: '预估经营欠款',
    platformSettlement: '平台结算',
    platformSubsidies: '平台补贴 - 其他',
    sourceNotes: '来源备注',
    internalOrder: "内部订单",
    internalOrderRefund: "内部订单退款",
    // 中文
    warehouseFeeLabel: "仓库费用",
    warehouseFeeRefundLabel: "仓库费退款",
    unsettled: '待结算',
    unsettledDesc: '尚未结算的订单金额，包括已完成但未达到结算条件的订单。页面展示的为选定时间内的未结算订单详情，包含商品金额、运费、预计结算时间、未结算原因等各项明细。当订单满足结算条件后，可通过下方去结算按钮发起结算流程。',
    goSettlement: '去结算',
    goSettlementDesc: '选择结算周期后，系统将显示该周期内可结算的订单详情。您可以查看订单列表，确认结算金额，然后点击结算按钮完成结算流程。',
    settledOrders: '已结算订单',
    settledOrdersDesc: '已结算订单金额，详细列出每笔已结算订单的明细，包括订单金额、商品总价、运费、退款、平台费用等各项明细。',
    unsettledReason: '未结算原因',
    expectedSettlementTime: '预计结算时间',
    activity: '收费项',
    qty: '数量',
    netAmount: '不含税金额',
    vat: '增值税',
    amountIncludeVat: '含税金额',
    expectedSettlementAmount: '预结算金额',
  },
  afterSale: {
    sellerReviewDeadlinePrompt: '卖家需在',
    noAction: '内完成审核，超时未处理自动审核通过',
    timedOutStatus: '00:00:00',
    BuyerAppliesReturn: '买家申请退货',
    InProcessing: '处理中',
    ReviewCompleted: '审核完成',
    ReturnProcessing: '退货处理中',
    BuyerInitiatesReturn: '买家发起退货申请',
    AfterSalesInformation: '售后信息',
    RefundAfterReceiptProducts: '已收货退款',
    ProductsReceived: '已收到货',
    ProductsNotReceived: '未收到货',
    AfterSalesNo: '售后编号',
    ApplicationAmount: '申请金额',
    BuyerEntitledRefund: '买家应收退款',
    AfterSalesReason: '售后原因',
    AfterSalesType: '售后类型',
    ReceiptStatus: '收货状态',
    ApplicationQuantity: '申请件数',
    QuantityToReturn: '需寄回数量',
    CustomerServiceArbitration: '平台处理结果',
    Return: '退货',
    TransactionInformation: '交易信息',
    RefundRequestAmount: '申请退款金额',
    sellerRefusedReturn: '卖家拒绝退货',
    returnReviewApprovedAwaitingShip: '退货审核通过，等待买家发货',
    awaitingBuyerShip: '等待买家发货',
    awaitingSellerReceive: '等待卖家收货',
    afterSalesCompleted: '售后完成',
    ReturnShippingInfo: '退货物流信息',
    ReturnShippingUpdates: '退货物流动态',
    buyerHasShipped: '买家已发货，退货商品运输中',
    ReturnRefund: '退货退款',
    returnItemDeliveredAwaitingSign: '退货商品已送达，等待卖家签收',
    returnCompletedProceedRefund: '退货已完成，进入退款流程',
    noReturnOnlyRefundSuccessful: '无需退货，仅退款成功',
    refundNumber: '退款编号',
    refundTime: '退款时间',
    buyerInitiatesOrderCancellation: '买家发起取消订单',
    sellerReviews: '卖家审核',
    buyerSubmittedOrderCancellation: '买家发起了取消订单申请',
    cancellationInProgressUrgeReview: '取消订单申请进行中，快点审核吧！',
    cancellationRequestApproved: '取消订单申请已通过',
    cancellationApprovedProceedRefund: '取消订单申请已通过，将进入退款流程',
    sellerRejectedCancellation: '卖家拒绝取消订单',
    cancellationRequestRejected: '取消订单申请已被驳回',
    unshippedRefund: '未发货退款',
    AmountApplied: '申请退款金额',
    RefundDestination: '退款去向',
    requestedRefundAmount: '申请退款金额',
    actualRefundAmount: '实际退款金额',
    refundFromSellerToBuyer: '从卖家订单货款退款给买家',
    buyerPaymentMethod: '买家支付方式',
    merchantPayoutMethod: '商家出款方式',
    productPayment: '商品费用',
    autoCancelOrderOnTimeout: '超时自动取消订单',
    autoConfirmReceiptPrompt: '该订单将在',
    receiptDueTime: '后自动确认收货',
    ReturnAndRefundSupported: '支持退货退款',
    ReturnsRefundsNotSupported: '不支持退货退款',
    GotoReview: '去审核',
    reviewTimeoutAutoApproved: '审核已超时，审核自动通过',
    shipmentTimeoutAutoCancelled: '发货已超时，订单已自动取消',
    orderAutoConfirmedReceipt: '订单已自动确认收货',
    Type: '类型',
    returnPath: '退回路径',
    returnPathDetail: '买家-钱包-余额',
    preOrderDepositDeduction: '预订金抵扣',
    preOrderReleaseStock: '预订单释放库存',
    preOrderSettlement: '预订单结算',
    returnArbitrationPending: '您有平台介入待处理事项',
    returnAuditInProgress: '退货申请审核中',
    cancelAuditInProgress: '取消订单审核中',
    afterSaleHandle: "售后处理",
    fillHandleInfoTip: "请填写处理结果及相关信息",
    handleResult: "处理结果",
  },
  editor: {
    characters: '字符',
    images: '图片',
  },
  balance: {
    viewDeductionRecord: '扣款记录',
    applicationHistory: '历史申请',
    deductionRecord: '扣款记录',
    deductionStatus: '扣款状态',
    success: '成功',
    failed: '失败',
    deductionMethod: '扣款方式',
    paymentStatus: '支付状态',
    paymentProcessing:'支付中',
    paymentSuccess: '支付成功',
    paymentCancelled: '支付取消',
    paymentFailed: '支付失败',
    failureReason: '失败原因',
    bankCard: '银行卡',
    withdrawalAmount: '提现金额',
    deductionInfo: '扣款信息',
    deductionInfoTip: '查看卖家本次扣款执行情况',
    settlementInfo: '结算信息',
    deductionSettlementTip: '本次扣款对应的结算信息',
    deductionSuccessNote: '该笔扣款已完成，扣款方式为{method}，支付状态为{status}。',
    applicationInfo: '申请信息',
    applicationInfoTip: '查看本次欠款申请及审核结果',
    reviewResult: '审核结果',
    reviewReasonPlaceholder: '请输入审核原因',
    applicationSettlementTip: '本次申请对应的结算周期与结算时间',
    applicationApprovedNote: '该申请已审核通过，当前记录用于查看历史欠款申请及对应结算信息。',
    applicationRejectedNote: '该申请审核未通过，当前记录用于查看历史欠款申请及对应结算信息。',
    applicationPendingNote: '该申请正在等待审核，当前记录用于查看历史欠款申请及对应结算信息。'
  },
  menu: {
    permission: '系统设置',
    dashboard: '仪表盘',
    brandAudit: '品牌审核',
    addProduct: '添加商品',
    editProduct: '修改商品',
    warehouseList: '仓库列表',
    roleList: '卖家角色',
    productList: '商品列表',
    productDetails: '商品详情',
    platformVerify: '平台审核',
    productVerify: '商品审核',
    productSort: '商品分类',
    brandManagement: '品牌管理',
    addBrand: '添加品牌',
    editBrand: '编辑品牌',
    specificationsList: '规格列表',
    unitOfMeasurement: '计量单位',
    platformRole: '平台角色',
    menuList: '平台菜单',
    addMenu: '新增菜单',
    updateMenu: '修改菜单',
    warehouse: '仓库管理',
    shopMenu: '卖家菜单',
    resourceList: '资源列表',
    platformUsers: '平台用户',
    mallUsers: '商城用户',
    shop: '卖家',
    shopManagement: '卖家管理',
    shopList: '卖家列表',
    shopApplyList: '卖家审核',
    reviewShop: '卖家审核',
    order: '订单管理',
    platformOrders: '平台订单',
    orderList: '订单列表',
    settlementList: '结算列表',
    pendingSettlement: "待结算订单",
    settledOrders: "已结算订单",
    buyerBalance: "买家余额申请",
    buyerBalanceDetail: "买家余额详情",
    sellerBalance: "卖家余额申请",
    sellerBalanceDetail: "卖家余额详情",
    settlementDebt: "结算欠款申请",
    reconciliationList: '对账列表',
    settings: '商品配置',
    parameterBinding: '参数绑定',
    warehouseAudit: '仓库审核',
    creditValue: '信用值',
    creditValueList: '信用值列表',
    business: '分销商',
    platform: '平台',
    Marketing: '营销',
    SecondKillActivityList: '秒杀活动列表',
    SecondsKillTimeList: '秒杀时间段列表',
    SecondsKillTimeSelection: '秒杀时间段选择',
    SeckillProductList: '秒杀商品列表',
    CouponList: '优惠券列表',
    AddCoupons: '添加优惠券',
    ModifyCoupon: '修改优惠券',
    CouponCollectionDetails: '优惠券领取详情',
    BrandRecommendation: '品牌推荐',
    NewProductRecommendation: '新品推荐',
    PopularRecommendation: '人气推荐',
    SpecialTopicRecommendation: '专题推荐',
    AdvertisingList: '广告列表',
    AddAds: '添加广告',
    EditorialAdvertising: '编辑广告',
    Permissions: '权限',
    AllocatingResources: '分配资源',
    ResourceClassification: '资源分类',
    settleDetails: '结算详情',
    template: '模板设置',
    emailTemplates: '消息模板',
    SystemConfiguration: '系统配置',
    product: '商品',
    financial: '财务结算',
    AfterSalesDetails: '售后详情',
    payment: '支付',
    quotation: '报价管理',
    mallUserAudit: "分销商审核",
    mallUserReviewDetail: "分销商审核详情",
    distributorAccountDetails: '分销商账号详情',
    reviewShopDetail: "货主审核详情",
    orderAuditList: '管理退货',
  },
  entry: {
    merchantType: '入驻类型',
    enterpriseInfo: "企业信息",
    individualMerchant: "个体经营者",
    enterpriseCompany: "企业/公司",
    shopName: "店铺名称",
    certificateFiles: "证明文件",
    personalInfo: "个人信息",
    legalPersonInfo: "法人信息",
    idProof: "身份证明",
    idFullName: "证件全名",
    corpNameTip: "企业名称",
    corpRegNoLabel: "企业注册编号",
    idTypeLabel: "身份证件类型",
    ukPassportOption: "护照",
    ukDrivingLicenceOption: "驾驶执照",
    channelOther: "其他",
    salesChannel: '销售渠道',
    uboTitle: "企业受益所有人",
    legalRepIdDocLabel: "法人身份证件",
    corpProofTitle: "企业主体证明",
    companiesHouseLabel: "公司注册证明",
    ukVatCertLabel: "英国VAT注册证明",
    supplementaryProofTitle: "补充证明材料",
    companyConstitutionLabel: "公司章程/组织大纲及章程",
    businessAddrProofLabel: "实际经营地址证明",
    bankAccountProofLabel: "银行账户证明",
    personalInfoTitle: "个人信息",
    personalNameLabel: "姓名（与证件一致）",
    birthDateLabel: "出生日期",
    idVerifyTitle: "身份验证",
    residenceVerifyTitle: "居住地址验证",
    bankStatementItem: "银行流水（近3个月）",
    utilityBillItem: "水电燃气账单（近3个月）",
    netMobileBillItem: "网络/手机账单（近3个月）",
    rentalContractItem: "租房合同（有效期内）",
    proofDocTypeLabel: "证明文件类型",
    addressProofFileLabel: "地址证明文件",
    entityType1: "英国个体经营者",
    entityType2: "离岸企业+英国VAT",
    entityType3: "英国本土企业",
    enterpriseName: '企业名称',
    contactInfoTitle: "联系方式",
    name: '姓名',
    phone: '联系电话',
    mainSalesScenarioLabel: "主要销售场景",
    salesTargetLabel: "销售给谁",
    businessBriefLabel: "业务简介",
    businessIntroductionTitle: "业务简介",
    otherSupplementaryDocsLabel: "其他补充材料",
    proofDocsLabel: "证明材料",
    businessLicense: '营业执照（或公司注册证明）',

    store: {
      title: '关联店铺信息',
      onlineStore: '线上店铺',
      platformType: '平台类型',
      platformTypePlaceholder: '请选择平台类型',
      storeUrl: '店铺链接',
      storeName: '店铺名称',
      physicalStoreInformation: '实体店铺信息',
      storeAddress: '店铺地址',
      storeImage: '店铺照片',
      physicalStoreLabel: "实体店铺",
    },

    identity: {
      individual: '个人创业/自由职业',
      employee: '公司/企业员工（福利销售）',
      student: '学生',
      other: '其他'
    },
  },
  "enterpriseApplication": {
    "personalInfo": {
      "businessInfo": "企业/公司信息填写",
      "companyName": "公司/企业名称",
      "registrationNumber": "统一社会信用代码/注册号",
      "companyType": "公司类型",
      "country": "国家/地区",
      "registerAddress": "公司注册地址",
      "companyPhone": "公司联系电话",
      "contactInfo": "联系人信息",
      "contactPersonName": "联系人姓名",
      "contactPosition": "联系人职位",
      "contactPhone": "联系人手机号"
    },
    "store": {
      "title": "关联店铺信息（至少提供一种）"
    },
    "vat": {
      title: 'VAT信息',
      "vatNo": "VAT税号"
    }
  },
  buyer: {
    evaluationContent: "评价内容",
    evaluationImages: "评价图片",
    ratingType: "评分类型",
    ratingStars: "评分星级",
    displayStatus: "展示状态",
    positiveReview: "好评",
    neutralReview: "中评",
    negativeReview: "差评",
    hasImages: "有图",
    productReviews: "商品评价",
    distAuditPending: "分销商正在审核，请耐心等待",
  },
  wallet: {
    paymentStatusQuerying: '查询支付状态',
    PaymentSuccessful: '支付成功',
    ProcessingPayment: '处理支付中',
    committedProtectingInformation: '我们致力于保护您的信息',
    BillingAddress: '账单地址',
    editNewBillingAddress: '编辑新的账单地址',
    payNow: '立即支付',
    paymentNotSuccessful: '支付未成功',
    SomeCommonIssues: '一些常见问题：',
    VerifyPaymentInformation: '验证付款信息',
    bankHaveFlagged: '您的银行可能已标记此交易',
    withdrawalPurchaseLimits: '检查您卡的提款或购买限额',
  },
  register: {
    PoweredBy: '由',
    PoweredBy2: '提供技术支持',
    Clause: '条款',
    Privacy: '隐私',
    firstName: '名字',
    lastName: '姓氏',
  },
  quotation: {
    title: 'HURIX内部报价',
    subtitle: '智能报价 · 精准核算 · 高效管理',
    quoteItems: {
      management: '报价项管理',
      search: '搜索报价项...',
      add: '添加报价项',
      edit: '编辑报价项',
      addSubtitle: '维护报价项基础信息、费率与服务内容',
      editSubtitle: '修改当前报价项信息，保存后立即生效',
      basicInfo: '基础信息',
      rateSettings: '费率设置',
      serviceContent: '服务内容',
      name: '报价项名称',
      nameEn: '英文报价项名称',
      rate: '默认费率',
      tax: '税额',
      taxRate: '税率',
      visibility: '客户可见性',
      action: '操作',
      inputName: '例如：国际空运（中国-英国）',
      inputNameEn: '例如：International Air Freight (CN-UK)',
      visible: '可见',
      hidden: '隐藏',
      visibleToClient: '对客户可见',
      required: '必填项',
      notes: '备注说明',
      inputNotes: '详细描述此项服务...',
      inputNotesEn: '请使用英文描述服务内容、适用范围和计费说明...',
      nameRequired: '请输入报价项名称',
      nameEnRequired: '请输入英文报价项名称',
      saveSuccess: '报价项保存成功',
      editSuccess: '报价项编辑成功',
      deleteConfirm: '确定要删除此报价项吗？',
      deleteSuccess: '报价项删除成功',
      cost: '默认成本',
      description: '服务内容',
      descriptionEn: '英文服务内容',
      searchSuccess: '搜索成功',
      currency: '货币符号',
      currencyRequired: '请选择货币符号',
      rateRequired: '请输入默认费率',
      costRequired: '请输入默认成本',
      taxRateRequired: '请输入税率',
      minZero: '值不能小于0'
    },
    templates: {
      management: '模板管理',
      search: '搜索模板...',
      create: '新建模板',
      edit: '编辑模板',
      quoteItems: '报价项目',
      status: '状态',
      usageCount: '使用次数',
      use: '使用',
      all: '全部',
      active: '启用中',
      inactive: '已停用',
      transport: '电商类',
      logistics: '物流类',
      custom: '自定义',
      emptyDesc: '暂无数据',
      name: '模板名称',
      nameEn: '英文模板名称',
      description: '模板描述',
      descriptionEn: '英文模板描述',
      type: '模板类型',
      inputName: '例如：标准国际运输报价单',
      inputNameEn: '例如：Standard International Transport Quote',
      inputDescription: '描述此模板的用途和特点...',
      inputDescriptionEn: 'Describe the purpose and features of this template...',
      selectItems: '选择项目',
      templateInfo: '模板信息',
      templateInfoTip: '维护模板基础信息和类型',
      selectQuoteItems: '选择报价项目',
      selectItemsTip: '不区分类型，按完整报价项列表选择',
      searchItems: '搜索报价项名称或服务内容...',
      selectedCount: '已选 {count} 项',
      itemCount: '共 {count} 项',
      step1: '1',
      step2: '2',
      step3: '3',
      basicInfo: '基本信息',
      complete: '完成设置',
      completeTip: '确认状态并保存模板',
      activeTip: '保存后模板立即可用于报价流程。',
      inactiveTip: '保留模板配置，但暂不用于报价流程。',
      noSelectedItems: '暂未选择报价项目',
      footerTip: '第二步展示完整报价项列表，可按名称或服务内容搜索。',
      prevStep: '上一步',
      nextStep: '下一步',
      nameRequired: '请输入模板名称',
      nameEnRequired: '请输入英文模板名称',
      itemsRequired: '请至少选择一个报价项目',
      createSuccess: '模板创建成功',
      editSuccess: '模板编辑成功',
      quickCreateInfo: '快速创建模板功能开发中',
      deleteConfirm: '确定要删除此模板吗？',
      deleteSuccess: '模板删除成功',
      update: '更新',
      updateTime: '更新时间'
    },
    quoteManagement: {
      title: '报价单管理',
      addQuote: '新增报价单',
      back: '返回',
      selectTemplate: '选择模板',
      inputClient: '输入客户名称',
      inputQuoteNumber: '输入报价单号',
      selectDate: '选择日期',
      validDateRequired: '请选择有效期',
      search: '搜索',
      reset: '重置',
      quoteNumber: '报价单号',
      clientName: '客户名称',
      template: '模板',
      validDate: '有效日期',
      createDate: '创建日期',
      actions: '操作',
      preview: '预览',
      previewQuote: '预览报价单',
      download: '下载',
      edit: '编辑',
      delete: '删除',
      deleteConfirm: '确定要删除此报价单吗？',
      deleteSuccess: '报价单删除成功',
      downloadSuccess: '报价单下载成功',
      searchSuccess: '搜索成功',
      // 创建报价单相关
      basicInfo: '报价单基础信息',
      basicInfoTip: '填写模板、客户和报价有效期',
      quoteItems: '报价项目',
      itemsTip: '共 {count} 个项目 · 数量、单价、税率支持直接调整',
      quoteTotal: '报价总额',
      costTotal: '成本合计',
      client: '客户名称',
      item: '收费项目',
      quantity: '数量',
      price: '单价',
      tax: '税额',
      taxRate: '税率',
      amount: '金额',
      profit: '利润',
      tip: '提示：内部成本项不会显示给客户',
      clear: '清空重填',
      calculate: '重新计算',
      save: '保存报价单',
      templateSelected: '模板选择成功',
      calculated: '计算完成',
      cleared: '表单已清空',
      saved: '报价单保存成功',
      amountFormula: '计算公式：数量 × 单价 × (1 + 税率%)',
      cost: '单位成本',
      finalCost: '最终成本',
      finalCostFormula: '最终成本 = 报价项成本 × 数量',
      profitFormula: '计算公式：(金额 - 最终成本) / 金额 × 100%',
      currencySymbol: '货币符号',
      selectTemplateFirst: '请先选择上方模板',
      enterCustomerName: '请输入客户名称',
      quoteNotEmpty: '报价单不能为空',
      // 预览相关
      fullscreen: '全屏',
      exitFullscreen: '退出全屏',
      formalQuotation: '正式报价单',
      quoteDate: '报价日期',
      notFilled: '未填写',
      subtotal: '小计',
      subtotalDesc: '共 {count} 项',
      taxDesc: '税率合计',
      total: '总计',
      totalDesc: '含税总价',
      export: '导出',
      exportSuccess: '导出成功'
    },
    help: {
      title: '使用帮助',
      guide: '快速开始指南',
      features: '功能介绍',
      tips: '使用技巧',
      faq: '常见问题',
      step1: '第一步：管理报价项',
      step2: '第二步：创建或选择模板',
      step3: '第三步：生成报价单',
      step4: '第四步：预览和导出',
      step1Desc: '在"报价项管理"中添加您的收费项目，包括名称、单位、单价和税率等信息。您可以编辑现有项目或删除不需要的项目。',
      step2Desc: '在"模板管理"中创建报价模板，或者选择已有的模板进行编辑。模板可以包含多个报价项，方便您快速生成报价单。',
      step3Desc: '在"创建报价单"中选择一个模板，系统会自动加载模板中的报价项。您可以根据需要调整数量、单价等信息。',
      step4Desc: '点击"预览报价单"按钮查看最终效果，确认无误后点击"生成PDF"导出报价单。',
      feature1: '报价项管理：添加、编辑、删除收费项目，设置基本信息和价格。',
      feature2: '模板管理：创建和管理报价模板，快速复用常用报价项组合。',
      feature3: '报价单生成：基于模板快速生成报价单，支持实时计算成本和利润。',
      feature4: '预览和导出：实时预览报价单效果，导出为PDF格式。',
      tip1: '使用模板可以大大提高报价效率，建议为常用的报价组合创建模板。',
      tip2: '在创建报价单时，您可以直接修改报价项的数量和单价，系统会自动重新计算成本和利润。',
      tip3: '预览报价单时，您可以点击右上角的全屏按钮查看完整效果。',
      tip4: '报价单中的利润会以不同颜色显示，绿色表示盈利，红色表示亏损。',
      faq1: '如何修改报价项的税率？',
      faq1Desc: '在报价项管理中编辑报价项，或者在创建报价单时直接修改对应行的税率。',
      faq2: '如何快速创建多个类似的报价单？',
      faq2Desc: '创建一个包含常用项目的模板，然后基于该模板创建新的报价单。',
      faq3: '如何调整报价单的样式？',
      faq3Desc: '当前系统使用固定的报价单模板，样式调整需要联系技术支持。',
      faq4: '导出的PDF文件保存在哪里？',
      faq4Desc: 'PDF文件会直接下载到您的浏览器默认下载目录。'
    }
  },
  returnParcel: {
    managementTitle: '退件管理',
    navigationLabel: '退件管理功能',
    packageCenter: '包裹中心',
    taskCenter: '待办任务',
    rulesAndFees: '规则与费用',
    packageCenterDescription: '查询进入 NGT 仓库的全部退件、当前状态及完整处理记录。',
    lastUpdated: '最后更新：{time}',
    number: '编号',
    all: '全部',
    pleaseSelect: '请选择',
    notSubmitted: '尚未提交',
    unlinkedOrder: '未关联订单',
    unlinked: '未关联',
    unrecognized: '未识别',
    notProvided: '未填写',
    notApplicable: '不适用',
    pendingConfirmation: '待确认',
    distributorPending: '分销商待确认',
    ownerPending: '货主待确认',
    thirdPartyOrder: '三方订单编号',
    orderNumber: 'HURIX 订单编号',
    returnOrderNumber: 'HURIX 退货编号',
    ngtPackageNumber: 'NGT 包裹号',
    applicationNumber: '退货包裹认领申请 ID',
    returnTrackingNumber: '退件运单号',
    ngtWarehouse: 'NGT 仓库',
    operator: '操作人',
    publicClaimApplication: '公共认领申请',
    waitingPlatform: '等待平台处理',
    exceptionCreated: '已产生异常',
    internalSettlement: '平台内部结算',
    platformInternalSettlement: 'HURIX 平台内部结算',
    noPaymentRequired: '无需支付',
    paymentSucceeded: '支付成功',
    systemAutomaticInstruction: '系统自动指令',
    systemInstruction: '系统指令',
    // 包裹中心列表
    packageTabAll: '全部包裹',
    packageTabPending: '待处理',
    packageTabStorage: '暂存区',
    packageTabCompleted: '已完成',
    filterKeyword: '输入退货运单号 / 包裹编码 / 订单号',
    filterAllStatuses: '选择状态',
    filterEmail: '输入邮箱',
    filterAllAuditStatuses: '选择审核状态',
    filterAllMatchMethods: '选择匹配方式',
    columnParcelProduct: '包裹 / 商品',
    columnOrderInfo: '订单信息',
    columnMatchMethod: '匹配方式',
    columnCurrentStatus: '当前状态',
    columnCreatedTime: '创建时间',
    packageCount: '共 {count} 个包裹',
    packageStatusStorage: '暂存中',
    packageStatusPendingOwnerReview: '待货主审核退货',
    packageStatusPlatformIntervention: '平台介入',
    packageStatusPendingDistributorInstruction: '待分销商下发指令',
    packageStatusPublicClaim: '公共认领中',
    packageStatusPendingWarehouseClaimReview: '待仓库审核认领',
    packageStatusPendingPlatformInstruction: '待平台下发指令',
    packageStatusPendingWarehouseExecution: '待 NGT 仓库执行',
    packageStatusWarehouseExecutionOverdue: '仓库执行超时',
    packageStatusCompleted: '已完成',
    matchTypeUnmatched: '未匹配',
    matchTypeAutomatic: '自动匹配',
    matchTypeLabelOrderNumber: '面单订单号匹配',
    matchTypePostcode: '邮编匹配',
    auditStatusPending: '待审核',
    auditStatusApproved: '审核通过',
    auditStatusRejected: '审核拒绝',
    statusTimeInstructionDeadline: '指令截止：{time}',
    statusTimeFreeStorage: '免费暂存至：{time}',
    statusTimePublicClaimEnter: '公共认领开始：{time}',
    statusTimePublicClaimExpire: '公共认领截止：{time}',
    // 待办任务列表
    taskTabAll: '全部待办',
    taskTabWarehouseReview: '待仓库审核',
    taskTabWarehouseExecution: '待仓库执行',
    taskTabPlatformReview: '待平台审核',
    taskTabException: '异常包裹',
    taskFilterAll: '全部',
    taskAuditApproved: '已通过',
    taskAuditRejected: '已驳回',
    taskAllDescription: '所有需要人工处理的退件集中在一个队列，方便统一查看和处理。',
    taskAllNotice: '公共认领到期无人认领，或分销商确认弃货后，包裹进入“待平台审核”。平台选择上架、弃货或销毁后，由 NGT 仓库执行。',
    taskWarehouseReviewDescription: '由 NGT 仓库对比分销商认领凭证和包裹实物，确认公共认领包裹的归属。',
    taskWarehouseReviewNotice: '分销商提交申请后，公共认领倒计时暂停；审核驳回后，从申请提交时保存的剩余时间继续。',
    taskWarehouseExecutionDescription: '执行分销商已提交并完成支付，或平台取得货权后下发的上架、弃货、销毁指令。',
    taskWarehouseExecutionNotice: '分销商指令须确认支付成功；平台自有包裹使用内部结算。仓库只能执行已下发的处置方式，不得自行修改。',
    taskPlatformReviewDescription: '平台统一审核已取得货权的无人认领或弃货包裹，并向 NGT 仓库下达处置指令。',
    taskPlatformReviewNotice: '平台可选择“上架至 HURIX”“弃货”或“销毁”。上架完成后，商品进入 HURIX 可售库存，由 HURIX 继续售卖。',
    taskExceptionDescription: '处理超过仓库执行期限、需要平台运营介入的包裹。',
    taskExceptionNotice: '调整执行期限不会撤销原指令或支付记录，所有修改均记录操作人、原因和修改前后数据。',
    taskCount: '共 {count} 个待办任务',
    columnCandidateOrders: '候选订单',
    columnSubmittedAt: '提交时间',
    columnInstructionParty: '指令方',
    columnEntryReason: '进入原因',
    matchScore: '匹配度 {score}%',
    platformReviewReasonPublicClaimExpired: '公共认领到期无人认领',
    platformReviewReasonDistributorDiscard: '分销商弃货',
    exceptionWarehouseOverdueNote: '转寄指令超过1个工作日仍未完成。原指令和支付保持有效，需要设置新的执行截止时间。',
    feeRecordCount: '共 {count} 条费用记录',
    feePaymentStatusPlaceholder: '选择支付状态',
    feeReturnExpressNoPlaceholder: '输入退货运单号',
    feeEmailPlaceholder: '输入邮箱',
    feeReturnPackage: '退货包裹',
    feeDistributor: '分销商',
    // 退货包裹详情
    detailTitle: '退货包裹详情',
    detailCreatedAt: '创建时间',
    detailProcessingTime: '处理时限',
    detailParcelInfo: '包裹信息',
    detailCarrier: '承运商',
    detailStorageDeadline: '暂存截止时间',
    detailInstructionDeadline: '指令截止时间',
    detailLinkedInfo: '关联信息',
    detailThirdPartyPlatform: '第三方平台',
    detailMatchingCriteria: '匹配依据',
    detailPublicClaimEnterTime: '进入公共认领时间',
    detailPublicClaimExpireTime: '公共认领到期时间',
    detailProductsAndImages: '商品与包裹图片',
    detailPackageImage: '包裹图片',
    noPackageImage: '暂无包裹图片',
    detailProductInfo: '商品信息',
    detailProductName: '商品名称',
    detailProductSpec: '商品规格',
    warehouseRentDurationValue: '{count}天',
    detailFees: '暂存与费用',
    detailWarehouseOperationsFee: '仓库操作费用',
    detailWarehouseOperationsTimes: '仓库操作次数',
    detailShippingFee: '转寄物流费',
    detailPaymentAmount: '本次支付金额',
    detailWarehouseRent: '仓租费用',
    detailWarehouseRentDuration: '仓租时长',
    detailPaymentNumber: '支付单号',
    detailPaymentStatus: '支付状态',
    detailPaymentTime: '支付时间',
    detailCommand: 'NGT 仓库指令',
    detailCommandType: '指令类型',
    detailCommandStatus: '指令状态',
    detailRemark: '备注',
    detailLogisticsCarrier: '物流承运商',
    detailLogisticsNumber: '物流单号',
    detailWeight: '重量',
    detailLogisticsTime: '转寄时间',
    detailExecutionResult: '执行结果',
    detailForwardingAddress: '转寄地址',
    detailVoucherFiles: '凭证文件',
    detailNoCommand: '暂无仓库指令',
    detailRecords: '完整处理日志',
    detailOperator: '操作人',
    detailNoRecords: '暂无处理记录',
    recordStatusUnknown: '未知',
    recordStatusReturnSubmitted: '退货请求已提交',
    recordStatusOwnerApproved: '货主审批：通过',
    recordStatusOwnerRejected: '货主审批：拒绝',
    recordStatusPlatformIntervention: '平台介入',
    recordStatusParcelArrived: '包裹到仓',
    recordStatusParcelMatched: '包裹匹配',
    recordStatusMatchSucceeded: '包裹匹配成功',
    recordStatusPublicClaimStarted: '包裹进入公共认领',
    recordStatusClaimSubmitted: '提交认领记录',
    recordStatusClaimApproved: '认领申请通过',
    recordStatusClaimRejected: '认领申请拒绝',
    recordStatusPendingDistributorInstruction: '待分销商下发指令',
    recordStatusDistributorInstructionIssued: '分销商下发指令',
    recordStatusPlatformHandling: '超时交给平台处理',
    recordStatusWarehouseDelayed: '仓库处理延迟',
    recordStatusWarehouseCompleted: '仓库处理完成',
    recordStatusPlatformInstructionIssued: '平台下发指令',
    detailLocation: '仓库货位',
    detailSettlementStatus: '结算状态',
    detailPaidWithNumber: '已支付 · {number}',
    detailCurrentOwnership: '当前货权',
    photoOuterPackage: '外包装',
    photoProduct: '商品实物',
    paymentStatusNone: '无需支付',
    paymentStatusPending: '待支付',
    paymentStatusPaid: '已支付',
    commandTypeStorage: '暂存',
    commandTypeDestroy: '销毁',
    commandTypeDiscard: '弃货',
    commandTypeForward: '转寄',
    commandTypeStock: '上架至 HURIX',
    commandStatusCreated: '已创建',
    commandStatusPendingPayment: '待支付',
    commandStatusExecuting: '执行中',
    commandStatusCompleted: '执行完成',
    commandStatusFailed: '下发失败',
    // 详情操作及弹窗
    reviewClaim: '审核认领',
    reviewAndIssue: '审核并下达指令',
    executeInstruction: '执行指令',
    adjustDeadline: '调整期限',
    rejectReview: '审核驳回',
    approveReview: '审核通过',
    claimReviewTitle: '认领审核',
    approveClaimTitle: '确认审核通过',
    rejectClaimTitle: '提交驳回结果',
    platformInstructionTitle: '平台审核与处置指令',
    executeCommandTitle: '执行{command}指令',
    adjustDeadlineTitle: '仓库执行超时',
    warehouseItem: '仓库实物',
    warehouseInfo: '仓库信息',
    claimMaterials: '分销商认领资料',
    claimApplicant: '申请人',
    outerPackage: '外包装',
    productPhysical: '商品实物',
    claimDescription: '认领说明',
    claimVoucher: '认领凭证',
    claimReviewNotice: '审核期间公共认领倒计时暂停。通过后进入该分销商暂存区；驳回后恢复剩余认领时间。',
    approveClaimNotice: '通过后，包裹将关联至申请分销商并进入其暂存区，重新计算免费期、仓储费及 7 个工作日自动弃货期限。',
    rejectReason: '驳回原因',
    reviewNote: '审核备注',
    reviewNoteRequired: '请输入审核备注',
    reviewNotePlaceholder: '请明确说明审核结果或需要补充、修正的资料',
    internalNote: '内部备注（选填）',
    internalNotePlaceholder: '仅平台和 NGT 人员可见',
    auditVoucher: '审核凭证',
    claimApplicationRequired: '未获取到认领申请编号，请刷新详情后重试',
    returnPackageIdRequired: '未获取到退货包裹编号，请刷新详情后重试',
    commandIdRequired: '未获取到退货包裹指令编号，请刷新详情后重试',
    returnSnRequired: '未获取到退货编号，请刷新详情后重试',
    platformInstructionNotice: '包裹已进入平台审核。请选择处置方式；提交后将生成 NGT 仓库执行任务。',
    disposalMethod: '处置方式',
    disposalMethodRequired: '请选择处置方式',
    stockCommandHelp: '验收后进入 HURIX 可售库存，由 HURIX 继续售卖',
    discardCommandHelp: '按仓库弃货流程处理',
    destroyCommandHelp: '销毁并回传处理凭证',
    stockHelpTitle: '上架说明',
    stockHelpDescription: '仓库需核验商品外观、包装及基本功能；符合可售标准后上架至 HURIX。不符合可售标准时，应退回平台重新审核。',
    platformRemarkPlaceholder: '填写商品状况、审核依据及仓库执行注意事项',
    instructionImmutable: '指令内容不可修改',
    carrierPlaceholder: '请选择承运商',
    carrierRequired: '请选择承运商',
    logisticsNumberPlaceholder: '填写转寄运单号',
    logisticsNumberRequired: '请输入转寄运单号',
    logisticsNumberLengthAndDigitRule: '请输入5-50位物流单号，至少包含1个数字',
    logisticsNumberCharacterRule: '仅支持字母、数字和单个连字符（-），且不能以连字符开头或结尾',
    actualWeight: '实际重量（kg）',
    weightRequired: '请输入实际重量',
    weightMinZero: '实际重量不能小于0',
    handoverTime: '交运时间',
    handoverTimeRequired: '请选择交运时间',
    selectTime: '选择日期和时间',
    executionNote: '执行备注',
    executionResultRequired: '请输入执行备注',
    executionResultPlaceholder: '记录实际执行结果和需要说明的情况',
    executionVoucher: '处理凭证',
    deadlineRemaining: '剩余 {time}',
    deadlineOverdue: '已超时 {time}',
    durationDayHour: '{days}天 {hours}小时',
    durationHourMinute: '{hours}小时 {minutes}分',
    originalDeadline: '原执行截止时间',
    newDeadline: '新的执行截止时间',
    newDeadlineRequired: '请选择新的执行截止时间',
    adjustmentReason: '调整原因',
    adjustmentReasonRequired: '请输入调整原因',
    adjustmentReasonPlaceholder: '说明延长执行窗口的原因',
    rejectProductMismatch: '商品不一致',
    rejectVariantMismatch: '规格或数量不一致',
    rejectInvalidEvidence: '订单凭证无效',
    rejectOwnershipUnproven: '无法证明包裹归属',
    rejectUnclearImages: '图片不清晰',
    rejectOther: '其他',
    productSummaryMore: '{name} 等 {count} 件商品',
    confirmApprove: '确认通过',
    confirmReject: '确认驳回',
    confirmIssueInstruction: '确认审核并下发指令',
    confirmExecution: '确认执行完成',
    confirmDeadline: '确认调整期限',
    uploadFailed: '文件上传失败',
    copiedMessage: '{label}已复制',
    copyFailedMessage: '复制失败，请手动选择编号',
    claimApprovedMessage: '认领审核已通过，包裹已进入分销商暂存区',
    claimRejectedMessage: '认领申请已驳回，公共认领倒计时已恢复',
    instructionIssuedMessage: '平台审核已完成',
    executionSavedMessage: '仓库执行结果已保存，并同步至包裹详情',
    deadlineUpdatedMessage: '新的执行期限已生效',
    filtersTrackingNumber: '退件运单号',
    filtersDistributor: '分销商',
    filtersDistributorAccount: '分销商账号',
    filtersAllCarriers: '全部承运商',
    timeDays: '{count}天',
    timeHours: '{count}小时',
    timeMinutes: '{count}分',
    timeOverdue: '已超时 {time}',
    timeRemaining: '剩余 {time}',
    statusPendingDistributorLink: '待分销商关联包裹',
    statusPendingMatch: '待确认匹配',
    statusPublicClaiming: '公共认领中',
    statusPendingWarehouseReview: '待仓库审核',
    statusPendingOwnerReview: '待货主审核退货',
    statusPendingDistributorInstruction: '待分销商下发指令',
    statusPendingPlatformReview: '待平台审核',
    statusPendingWarehouseExecution: '待 NGT 仓库执行',
    statusInStorage: '暂存中',
    statusWarehouseOverdue: '仓库执行超时',
    statusCompleted: '已完成',
    statusDiscarded: '已自动弃货',
    statusDestroyed: '已销毁',
    statusForwarded: '已转寄',
    matchThirdOrder: '三方订单号匹配',
    matchPostcodeCandidate: '邮编候选匹配',
    matchUnableMatch: '无法匹配',
    matchPublicClaimApplication: '公共认领申请',
    matchThirdReturnCallback: '三方退货回调',
    scenarioScenario1: '场景 1',
    scenarioScenario3A: '场景 3A',
    scenarioScenario3B: '场景 3B',
    scenarioScenario4: '场景 4',
    instructionsForward: '转寄',
    instructionsStock: '上架至 HURIX',
    instructionsDiscard: '弃货',
    instructionsDestroy: '销毁',
    partiesHurixPlatform: 'HURIX 平台',
    partiesDistributorWithName: '分销商 {name}',
    partiesOwnerWithName: '货主 {name}',
    partiesPlatformOperationsWithName: '平台运营 · {name}',
    handlersWaitingDistributorClaim: '等待分销商认领',
    handlersPlatformAdjustDeadline: '平台运营 · 待调整执行期限',
    handlersPlatformHurixAdmin: '平台运营 · hurix_admin',
    handlersOrderMatchService: 'HURIX 订单匹配服务',
    handlersMatchService: 'HURIX 匹配服务',
    handlersSystem: 'HURIX 系统',
    handlersBillingService: 'HURIX 计费服务',
    handlersPlatformOperations: '平台运营',
    handlersProcessCompleted: '流程已完成',
    feesTitle: '费用明细',
    feesDescription: '查询分销商退件产生的操作费、转寄物流费和暂存仓储费。',
    feesOperationTimes: '操作次数：{count}',
    feesStorageDuration: '仓租时长：{count}',
    feesColumnsWarehouseOperations: '仓库操作费 / 次数',
    feesColumnsShippingFee: '转寄物流费',
    feesColumnsWarehouseRent: '仓租费用 / 时长',
    feesColumnsPaymentAmount: '本次支付金额',
    feesColumnsPaymentStatus: '支付状态',
    feesColumnsPaymentInfo: '支付单号',
    feesColumnsCreatedAt: '产生时间',
    rulesBusinessRules: '业务规则',
    rulesPageTitle: '规则与费用',
    rulesDescription: '查看退件处理时限和转寄物流费的重量阶梯。',
    rulesTimingTitle: '业务时限',
    rulesFeeTitle: '收费规则',
    rulesReadOnly: '只读业务规则',
    rulesFreightWeightTierPricing: '按重量阶梯计费',
    rulesFreightStartWeight: '起始重量',
    rulesFreightEndWeight: '截止重量',
    rulesFreightForwardingFee: '转寄运费',
    rulesFreightUnitKg: 'kg',
    rulesFreightAndAbove: '及以上',
    rulesFreightPendingConfiguration: '待配置',
    rulesFreightTierStartLabel: '第 {number} 档起始重量',
    rulesFreightTierEndLabel: '第 {number} 档截止重量',
    rulesFreightTierFeeLabel: '第 {number} 档转寄运费',
    rulesFreightRemoteAreaLink: '查看偏远地区',
    rulesFreightBoundaryHint: '以仓库称重结果匹配档位；恰好等于分界重量时归入前一档，按命中档位收费，不逐档累加。',
    rulesFreightRegionsDomesticName: '英国本土',
    rulesFreightRegionsDomesticDescription: '适用于英国本土非偏远地区的退件转寄。',
    rulesFreightRegionsRemoteName: '偏远地区',
    rulesFreightRegionsRemoteDescription: '大陆地区包括英格兰、威尔士和苏格兰，偏远地区则指北爱尔兰和苏格兰高地。计算卖家类别时，我们会同时考虑取件和送件量；但送件包裹将始终按照送件费率表收费。',
    rulesFreightRegionsOtherName: '其他',
    rulesFreightRegionsOtherDescription: '当包裹中的商品不属于 HURIX 商品时，系统将按照“其他”计费规则收取转寄物流费。',
    eventsPackageArrived: '包裹到达 NGT 仓库',
    eventsMatchedHurixOrder: '匹配到 HURIX 订单',
    eventsCandidatesGenerated: '生成候选订单',
    eventsEnteredPublicClaim: '进入公共认领区',
    eventsClaimSubmitted: '提交认领申请',
    eventsOwnerApproved: '货主审核通过',
    eventsInstructionPaid: '提交 NGT 仓库指令并支付',
    eventsAutoEnteredStorage: '包裹自动进入暂存区',
    eventsStorageFeeStarted: '开始计算仓储费',
    eventsWarehouseExecutionOverdue: '仓库执行超时',
    eventsOwnershipTransferred: '公共认领到期，货权转移至平台',
    eventsEnteredDistributorStorage: '包裹进入分销商暂存区',
    eventsDistributorDiscarded: '分销商确认弃货',
    eventsOrderLinkedManually: '人工确认关联订单',
    eventsClaimApproved: '认领审核通过',
    eventsClaimRejected: '认领审核驳回',
    eventsPlatformInstructionIssued: '平台下发 NGT 仓库指令',
    eventsInstructionCompleted: '仓库指令执行完成',
    eventsWarehouseDeadlineAdjusted: '调整仓库执行期限',
    eventDescriptionsScanAndUpload: '扫描退件运单号并上传面单、外包装照片',
    eventDescriptionsThirdOrderMatched: '三方订单号匹配成功，已通知分销商确认',
    eventDescriptionsNoThirdOrderRecognized: '面单未识别到有效三方订单号',
    eventDescriptionsTwoCandidatesGenerated: '根据退货人邮编生成 2 笔候选订单',
    eventDescriptionsArrivalScanCompleted: '完成到仓扫描',
    eventDescriptionsNoReliableMatch: '未获得可信订单或分销商匹配结果',
    eventDescriptionsOwnershipUnconfirmed: '无法确认包裹归属',
    eventDescriptionsClaimCountdownPaused: '公共认领倒计时已暂停，剩余5个工作日4小时',
    eventDescriptionsOwnerApprovedWithAddress: '同意退货并提供退货地址',
    eventDescriptionsForwardPaid: '指令：转寄；支付单：PAY-260916-1051',
    eventDescriptionsDistributorLinkOverdue: '分销商超过1个工作日未关联包裹',
    eventDescriptionsFreePeriodEnded: '已结束前3个自然日免费期',
    eventDescriptionsForwardPaymentSucceeded: '指令：转寄；支付成功',
    eventDescriptionsInstructionPaymentRemainValid: '原售后、指令及支付保持有效，等待 IT 调整期限',
    eventDescriptionsClaimExpiredPlatformTask: '满7个工作日仍无人认领，已生成平台处置待办',
    eventDescriptionsOwnerReviewCompleted: '货主审核完成后等待分销商下达仓库指令',
    eventDescriptionsDistributorTransferredOwnership: '分销商放弃包裹货权，已转交平台统一审核处置',
    eventDescriptionsCandidateOrdersRejected: '候选订单均无法与实物确认',
    eventDescriptionsManualOrderLinked: '已关联订单 {order}',
    eventDescriptionsClaimApprovedStorage: '包裹已关联分销商并进入暂存区',
    eventDescriptionsClaimRejectedCountdown: '恢复公共认领剩余时间',
    eventDescriptionsPlatformInstructionIssuedDesc: '指令：{instruction}；按平台标准流程执行',
    eventDescriptionsExecutionSaved: '已回填执行结果及处理凭证',
    eventDescriptionsDeadlineAdjustedDesc: '已设置新的执行截止时间，原指令和支付保持有效',
  },
  exclusiveLink: {
    title: '专属链接',
    linkLabel: '链接地址',
    linkPlaceholder: '请输入您的专属链接',
    linkRequired: '链接地址不能为空',
    noLinkToCopy: '暂无链接可复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    copy: '复制',
    tips: '推广指南',
    tip1: '分享分销商推广链接，邀请他人注册成为我们的分销商，共同开拓市场',
    tip2: '分享卖家推广链接，邀请优质商家加入我们的供应链，实现合作共赢',
    promotionType: '推广类型',
    productPromotion: '分销商',
    shopPromotion: '卖家',
    productPromotionLink: '分销商推广链接',
    shopPromotionLink: '卖家推广链接',
    productPromotionQRCode: '分销商推广二维码',
    shopPromotionQRCode: '卖家推广二维码',
    clickToCopy: '点击复制',
    generating: '生成中',
    qrCodeGenerating: '二维码生成中，请稍后再试',
    qrCodeCopied: '二维码图片已复制',
    qrCodeCopyFailed: '复制二维码图片失败'
  },
  shopApply: {
    salesRepresentative: '销售代表',
    salesRepEmail: "销售代表邮箱",
    enterEmail: '请输入邮箱',
    sellerEmail: '卖家邮箱',
    buyerEmail: '买家邮箱',
    sellerShopName: '卖家/店铺',
    descPending: '商品正在审核，请耐心等待',
    descApproved: '商品审核已通过，可上架销售',
    descRejected: '商品未通过审核，需修改后重新提交',
    sellerDescPending: '货主正在审核，请耐心等待',
    sellerDescApproved: '货主审核已通过，可正常开展业务',
    sellerDescRejected: '货主未通过审核，需修改后重新提交',
    accountShopLabel: "账号/店铺",
    accountLabel: "账号",
    SoleTrader: "个体",
    EstablishedEntity: "企业",
  },
  activity: {
    fissionActivityConfig: "裂变活动配置",
  },
  newProductDetail: {
    systemAudit: "系统审核",
    manualReviewState: "转人工审核",
    manualReviewText: "转人工",
    aiConfidence: "AI置信度",
    auditResult: "当前审核结果",
    approvedForRelease: "初审通过",
    rejectedForRelease: "审核拒绝",
    suggestion: "建议",
    auditReason: "审核理由",
    violationItems: "违规条目",
    manualReview: "人工审核",
    pendingAction: "（待操作）",
    manualReviewDescription: "可参考左侧系统AI记录完成二次判定",
    finalManualApprovalResult: "审核结果",
    reviewApprovedForRelease: "审核通过，允许发布",
    reviewRejectedForRelease: "审核驳回，不予发布",
    manualReviewOpinion: "审核意见"
  },
  buyerInsight: {
    title: '分销洞察',
    allDistributors: '全部分销商',
    corePreferenceTags: '核心偏好标签',
    tagCount: '标签数量',
    ordersLast30Days: '近30天下单',
    collectionsLast30Days: '近30天收藏',
    viewsLast30Days: '近30天浏览',
    collectionBehavior: '收藏行为',
    dataLast7Days: '近7天数据',
    distributorEmail: '分销商邮箱',
    distributorEmailPlaceholder: '输入分销商邮箱',
    enabledStatus: '启用状态',
    enabledStatusPlaceholder: '选择账号启用状态',
    cancellationStatus: '注销状态',
    cancellationStatusPlaceholder: '选择账号注销状态',
    enabled: '启用',
    disabled: '禁用',
    normal: '正常',
    deleted: '已删除',
    preferenceTags: '偏好标签',
    preferenceTagsPlaceholder: '选择偏好标签',
    createdTime: '创建时间',
    distributorList: '分销商列表',
    resultCount: '{count} 个结果',
    contactDistributor: '联系分销商',
    detail: '详情',
    orderCount: '{count} 单',
    noPreferenceTags: '暂无偏好标签',
    dataNote: '数据基于真实行为统计 · 标签更新 T+1',
    confirmStatusChange: '确定修改该分销商的启用状态吗？',
    statusUpdated: '启用状态修改成功',
    noContactInfo: '暂无该分销商的会话信息',
    justNow: '刚刚',
    minutesAgo: '{count}分钟前',
    hoursAgo: '{count}小时前',
    oneDayAgo: '1天前',
    twoDaysAgo: '2天前',
    daysAgo: '{count}天前',
    activityWithinSevenDays: '7天内',
    notLoggedInRecently: '最近未登录',
    backToDistributorList: '返回分销商列表',
    registeredAt: '注册时间 {time}',
    lastActiveAt: '最近活跃 {time}',
    productCategoryPreference: '商品分类标签 · 偏好强度',
    preferenceRanking: '偏好排序',
    coreTag: '核心',
    primaryTag: '主要',
    interestTag: '兴趣',
    newUserTag: '新用户/未分类',
    behaviorOverview: '行为数据概览',
    browseLast7Days: '近7天浏览',
    collectionLast7Days: '近7天收藏',
    orderLast7Days: '近7天下单',
    browseLast30Days: '近30天浏览 {count}',
    collectionCount: '收藏 {count}',
    orderQuantity: '下单 {count}',
    orderHistory: '历史下单记录',
    latestOrders: '最近{count}笔',
    noOrderHistory: '暂无历史下单记录',
    viewAllOrders: '查看全部订单',
    relatedProductRecommendations: '关联商品推荐',
    purchased: '已购买',
    collected: '已收藏',
    browsed: '已浏览',
    purchasedTimes: '已购{count}次',
    noRelatedProducts: '暂无关联商品',
    platformTagAnalysis: '平台标签统计分析',
    noCategoryStatistics: '暂无分类统计数据',
    profileRuleButton: '画像规则',
    profileRules: {
      kicker: 'PROFILE GUIDE',
      title: '分销商画像规则',
      intro: '了解行为如何转化为偏好标签，以及这些标签如何用于商品推荐。',
      close: '关闭画像规则',
      tocLabel: '规则目录',
      tocBehavior: '行为口径',
      tocScore: '偏好计分',
      tocTags: '标签分级',
      tocUpdates: '更新频率',
      tocRecommend: '推荐应用',
      section01: '01',
      section02: '02',
      section03: '03',
      section04: '04',
      section05: '05',
      behaviorTitle: '哪些行为会计入画像？',
      behaviorIntroPrefix: '按',
      behaviorIntroSubject: '商品所属分类',
      behaviorIntroSuffix: '汇总分销商的有效行为。不同的行为代表不同程度的购买意向，因此赋予不同权重。',
      behaviorColumn: '行为',
      conditionColumn: '有效条件',
      weightColumn: '每次权重',
      orderBehavior: '下单',
      orderCondition: '订单支付成功后计入',
      orderWeight: '10',
      collectBehavior: '收藏',
      collectCondition: '用户点击商品收藏按钮',
      collectWeight: '5',
      browseBehavior: '浏览',
      browseCondition: '进入商品详情页并停留至少 3 秒，减少误触影响',
      browseWeight: '1',
      scoreTitle: '分类偏好得分如何计算？',
      scoreIntroPrefix: '每个分类分别计分：',
      scoreIntroStrong: '行为越强、次数越多、发生时间越近，得分越高。',
      scoreIntroSuffix: '统计最近 90 天的行为，超过 90 天的记录不再计入；统计窗口可配置。',
      scoreFormula: '分类偏好得分 = Σ（行为权重 × 行为次数 × 时间衰减系数）',
      decayFormula: '时间衰减系数 = 0.5',
      decayExponent: '距今天数 ÷ 30',
      decayHint: '每过 30 天，一次行为的计分贡献减半。',
      todayRatio: '100%',
      today: '今天',
      days30Ratio: '50%',
      days30Ago: '30 天前',
      days60Ratio: '25%',
      days60Ago: '60 天前',
      days90Ratio: '12.5%',
      days90Ago: '90 天前',
      scoreAccumulation: '同一分类中，每发生一次有效行为就累加一次。不同日期的行为应分别衰减后再求和；只有衰减系数相同的行为，才可直接合并次数。',
      exampleTitle: '示例：同一分类有三组行为',
      exampleBrowsePrefix: '浏览 5 次，衰减系数 1：1 × 5 × 1 =',
      exampleBrowseScore: '5 分',
      exampleCollectPrefix: '收藏 2 次，衰减系数 0.8：5 × 2 × 0.8 =',
      exampleCollectScore: '8 分',
      exampleOrderPrefix: '下单 1 次，衰减系数 0.9：10 × 1 × 0.9 =',
      exampleOrderScore: '9 分',
      exampleTotalPrefix: '该分类偏好得分为：5 + 8 + 9 =',
      exampleTotalScore: '22 分。',
      scoreNote: '偏好得分用于比较分类偏好，并非百分比，也没有 100 分上限。页面中的近 7 天、近 30 天行为汇总，与画像的近 90 天计分窗口是不同口径。',
      tagsTitle: '如何生成偏好标签？',
      tagsIntroPrefix: '以',
      tagsIntroSubject: '当前分销商在全部商品分类上的平均得分',
      tagsIntroSuffix: '为基准，判断各分类的偏好强度。从高等级向低等级判断，同一分类只生成一个等级的标签。',
      tagLevelColumn: '标签等级',
      criteriaColumn: '判定条件',
      corePreference: '核心偏好',
      coreCriteria: '分类得分 ≥ 平均分的 2 倍',
      primaryPreference: '主要偏好',
      primaryCriteria: '分类得分 ≥ 平均分的 1.2 倍，且 < 2 倍',
      interest: '兴趣',
      interestCriteria: '分类得分 > 0，且 < 平均分的 1.2 倍',
      newUser: '新用户/未分类',
      newUserCriteria: '无任何可用于画像的行为数据',
      tagFormatPrefix: '标签采用“等级－分类名”的形式，例如“核心偏好－母婴”。按分类得分从高到低排序，',
      tagLimit: '每位分销商最多保留 5 个标签',
      tagFormatSuffix: '。',
      tagsExample: '例如全部分类平均分为 20：得分 ≥ 40 为核心偏好，24 ≤ 得分 < 40 为主要偏好，0 < 得分 < 24 为兴趣。',
      updatesTitle: '标签何时更新？',
      browseUpdateDescription: '每日凌晨批量处理前一天的有效浏览行为，并更新标签，即 T+1 更新。',
      recommendTitle: '偏好如何用于商品推荐？',
      newProductsTitle: '首页「新品上市」',
      newProductsDescription: '优先选取分销商偏好得分最高的 3 个分类，推荐这些分类下的新品。',
      guessYouLikeTitle: '首页「猜你喜欢」',
      guessYouLikeDescription: '从分销商浏览或收藏过、但尚未下单的分类中选取同类商品，再按商品热度进行推荐。',
      popularityFormula: '商品热度参考：近 7 天浏览量、收藏量、销量',
      popularityHint: '将三个指标归一化后综合计算，避免不同指标的量级影响排序。',
      safeHint: '查看规则不会清除当前筛选或切换账号',
      returnButton: '返回页面'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js